import { default as awardsGZE03KY3bbMeta } from "/data/pages/about-us/awards.vue?macro=true";
import { default as in_45the_45media3XkjronnXvMeta } from "/data/pages/about-us/in-the-media.vue?macro=true";
import { default as indexw4ONCROkyTMeta } from "/data/pages/about-us/index.vue?macro=true";
import { default as partnersvx9hifiWVYMeta } from "/data/pages/about-us/partners.vue?macro=true";
import { default as indexfo5VOb1sbeMeta } from "/data/pages/account/[page]/index.vue?macro=true";
import { default as account_45cardv0ubeQnsOBMeta } from "/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue?macro=true";
import { default as indexlWWDf54wTDMeta } from "/data/pages/account/[page]/protected/views/account-settings/index.vue?macro=true";
import { default as delete_45accountFWElTUQQYpMeta } from "/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue?macro=true";
import { default as delivery_45addressp3W0d1NjonMeta } from "/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue?macro=true";
import { default as emaildPRsz9lcXNMeta } from "/data/pages/account/[page]/protected/views/account-settings/sections/email.vue?macro=true";
import { default as indexopwKIz2VbqMeta } from "/data/pages/account/[page]/protected/views/account-settings/sections/index.ts?macro=true";
import { default as new_45emailqb16V6BaG6Meta } from "/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue?macro=true";
import { default as password7pYgeVy1fMMeta } from "/data/pages/account/[page]/protected/views/account-settings/sections/password.vue?macro=true";
import { default as personal_45detailsqBwHqe4JkdMeta } from "/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue?macro=true";
import { default as phone_45numberElsv4wwgmBMeta } from "/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue?macro=true";
import { default as device_45signoutdsr9bcVHE4Meta } from "/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue?macro=true";
import { default as indexRd1ZMxNn5bMeta } from "/data/pages/account/[page]/protected/views/order-history/index.vue?macro=true";
import { default as device_45signoutEa8ed5ZbwHMeta } from "/data/pages/account/[page]/protected/views/security/components/device-signout.vue?macro=true";
import { default as indexz1wzNUfIjJMeta } from "/data/pages/account/[page]/protected/views/security/index.vue?macro=true";
import { default as auth_45containerUm5Lrhj0IwMeta } from "/data/pages/account/[page]/public/components/auth-container.vue?macro=true";
import { default as auth_45windowzXElIeYSiiMeta } from "/data/pages/account/[page]/public/components/auth-window.vue?macro=true";
import { default as page_45headerwWpL8Krq7tMeta } from "/data/pages/account/[page]/public/components/page-header.vue?macro=true";
import { default as loginkkIGVYMbBJMeta } from "/data/pages/account/[page]/public/views/login.vue?macro=true";
import { default as password_45resetLMIFhG83YJMeta } from "/data/pages/account/[page]/public/views/password-reset.vue?macro=true";
import { default as reset_45password9XiWnOvvWVMeta } from "/data/pages/account/[page]/public/views/reset-password.vue?macro=true";
import { default as signupU5jtSSJqIRMeta } from "/data/pages/account/[page]/public/views/signup.vue?macro=true";
import { default as verify_45emailkXhkmHueRWMeta } from "/data/pages/account/[page]/public/views/verify-email.vue?macro=true";
import { default as verify_45updated_45email6k3D7ouiQXMeta } from "/data/pages/account/[page]/public/views/verify-updated-email.vue?macro=true";
import { default as dashboard_45cardy8jkOjeVcjMeta } from "/data/pages/account/components/dashboard-card.vue?macro=true";
import { default as indexX6Tsj9kTOCMeta } from "/data/pages/account/index.vue?macro=true";
import { default as _91slug_93cXioxiEr7bMeta } from "/data/pages/blog/[slug].vue?macro=true";
import { default as _91slug_93BF43XaeoiDMeta } from "/data/pages/blog/authors/[slug].vue?macro=true";
import { default as indexjKH6jSfTSdMeta } from "/data/pages/blog/authors/index.vue?macro=true";
import { default as _91slug_93cEB1nN3s1oMeta } from "/data/pages/blog/categories/[slug].vue?macro=true";
import { default as index3JdQccMEcZMeta } from "/data/pages/blog/index.vue?macro=true";
import { default as _91slug_93W2c0teDQWlMeta } from "/data/pages/blog/tags/[slug].vue?macro=true";
import { default as indexVag119Ai9QMeta } from "/data/pages/checkout/index.vue?macro=true";
import { default as thank_45youjeL9gqfYoWMeta } from "/data/pages/checkout/thank-you.vue?macro=true";
import { default as _91slug_93eL5cIth4EPMeta } from "/data/pages/clinics/[slug].vue?macro=true";
import { default as city_45listing9c2P70j0p9Meta } from "/data/pages/clinics/components/city-listing.vue?macro=true";
import { default as detail_45viewFmlqOz8UAaMeta } from "/data/pages/clinics/components/detail-view.vue?macro=true";
import { default as index5eSz7sUw3TMeta } from "/data/pages/clinics/index.vue?macro=true";
import { default as contact_45usVb7LZb4YQxMeta } from "/data/pages/contact-us.vue?macro=true";
import { default as indexojFm3fXhJiMeta } from "/data/pages/direct-payment/[order_token]/index.vue?macro=true";
import { default as _91slug_93wLojpWP9YDMeta } from "/data/pages/faqs/[slug].vue?macro=true";
import { default as indexLfZweG7Ef2Meta } from "/data/pages/faqs/index.vue?macro=true";
import { default as index0sTCdVluXDMeta } from "/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue?macro=true";
import { default as _91condition_93IYA8PUM8TrMeta } from "/data/pages/help-and-advice/[category]/[slug]/[condition].vue?macro=true";
import { default as indexZeiT6zQX5VMeta } from "/data/pages/help-and-advice/[category]/[slug]/index.vue?macro=true";
import { default as index9wTWHSpoWsMeta } from "/data/pages/help-and-advice/[category]/index.vue?macro=true";
import { default as indexjAaK7ryr1uMeta } from "/data/pages/help-and-advice/index.vue?macro=true";
import { default as indexwJM0pWSZGwMeta } from "/data/pages/index.vue?macro=true";
import { default as _91slug_93VAORsljsIBMeta } from "/data/pages/legal-and-privacy/[slug].vue?macro=true";
import { default as indexSWPrnbyjTJMeta } from "/data/pages/legal-and-privacy/index.vue?macro=true";
import { default as indexJDLZt6uUb1Meta } from "/data/pages/manual-payment/[token]/index.vue?macro=true";
import { default as indexS1tlGZUMklMeta } from "/data/pages/order-processing/index.vue?macro=true";
import { default as policy_45detailtnulJGjISmMeta } from "/data/pages/policy-detail.vue?macro=true";
import { default as index2QwGis8PcNMeta } from "/data/pages/reviews/index.vue?macro=true";
import { default as indexjNcQzb30nMMeta } from "/data/pages/tests/[id]/[slug]/index.vue?macro=true";
import { default as index1s4p7SZOGtMeta } from "/data/pages/tests/[id]/index.vue?macro=true";
import { default as indexi5j1BAjR1wMeta } from "/data/pages/tests/index.vue?macro=true";
export default [
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en",
    path: awardsGZE03KY3bbMeta?.path ?? "/en/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-ca",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-ca/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-co",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-co/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___es-co",
    path: awardsGZE03KY3bbMeta?.path ?? "/es-co/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-cr",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-cr/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___es-cr",
    path: awardsGZE03KY3bbMeta?.path ?? "/es-cr/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-es",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-es/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___es",
    path: awardsGZE03KY3bbMeta?.path ?? "/es/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___es-es",
    path: awardsGZE03KY3bbMeta?.path ?? "/es-es/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-ge",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-ge/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-gb",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-gb/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-us",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-us/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-hk",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-hk/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-hu",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-hu/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___hu-hu",
    path: awardsGZE03KY3bbMeta?.path ?? "/hu-hu/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-in",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-in/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-ie",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-ie/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-au",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-au/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-pa",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-pa/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___es-pa",
    path: awardsGZE03KY3bbMeta?.path ?? "/es-pa/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-pe",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-pe/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___es-pe",
    path: awardsGZE03KY3bbMeta?.path ?? "/es-pe/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-pl",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-pl/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___pl-pl",
    path: awardsGZE03KY3bbMeta?.path ?? "/pl-pl/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-pt",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-pt/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___pt-pt",
    path: awardsGZE03KY3bbMeta?.path ?? "/pt-pt/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-ro",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-ro/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-za",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-za/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-ae",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-ae/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-sa",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-sa/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-om",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-om/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-kw",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-kw/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-bh",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-bh/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-qa",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-qa/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-ke",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-ke/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsGZE03KY3bbMeta?.name ?? "about-us-awards___en-ng",
    path: awardsGZE03KY3bbMeta?.path ?? "/en-ng/about-us/awards",
    meta: awardsGZE03KY3bbMeta || {},
    alias: awardsGZE03KY3bbMeta?.alias || [],
    redirect: awardsGZE03KY3bbMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/awards.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-ca",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-ca/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-co",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-co/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___es-co",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/es-co/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-cr",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-cr/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___es-cr",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/es-cr/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-es",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-es/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___es",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/es/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___es-es",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/es-es/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-ge",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-ge/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-gb",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-gb/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-us",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-us/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-hk",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-hk/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-hu",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-hu/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___hu-hu",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/hu-hu/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-in",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-in/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-ie",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-ie/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-au",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-au/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-pa",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-pa/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___es-pa",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/es-pa/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-pe",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-pe/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___es-pe",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/es-pe/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-pl",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-pl/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___pl-pl",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/pl-pl/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-pt",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-pt/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___pt-pt",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/pt-pt/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-ro",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-ro/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-za",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-za/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-ae",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-ae/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-sa",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-sa/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-om",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-om/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-kw",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-kw/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-bh",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-bh/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-qa",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-qa/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-ke",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-ke/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: in_45the_45media3XkjronnXvMeta?.name ?? "about-us-in-the-media___en-ng",
    path: in_45the_45media3XkjronnXvMeta?.path ?? "/en-ng/about-us/in-the-media",
    meta: in_45the_45media3XkjronnXvMeta || {},
    alias: in_45the_45media3XkjronnXvMeta?.alias || [],
    redirect: in_45the_45media3XkjronnXvMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/in-the-media.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en",
    path: indexw4ONCROkyTMeta?.path ?? "/en/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-ca",
    path: indexw4ONCROkyTMeta?.path ?? "/en-ca/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-co",
    path: indexw4ONCROkyTMeta?.path ?? "/en-co/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___es-co",
    path: indexw4ONCROkyTMeta?.path ?? "/es-co/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-cr",
    path: indexw4ONCROkyTMeta?.path ?? "/en-cr/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___es-cr",
    path: indexw4ONCROkyTMeta?.path ?? "/es-cr/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-es",
    path: indexw4ONCROkyTMeta?.path ?? "/en-es/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___es",
    path: indexw4ONCROkyTMeta?.path ?? "/es/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___es-es",
    path: indexw4ONCROkyTMeta?.path ?? "/es-es/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-ge",
    path: indexw4ONCROkyTMeta?.path ?? "/en-ge/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-gb",
    path: indexw4ONCROkyTMeta?.path ?? "/en-gb/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-us",
    path: indexw4ONCROkyTMeta?.path ?? "/en-us/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-hk",
    path: indexw4ONCROkyTMeta?.path ?? "/en-hk/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-hu",
    path: indexw4ONCROkyTMeta?.path ?? "/en-hu/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___hu-hu",
    path: indexw4ONCROkyTMeta?.path ?? "/hu-hu/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-in",
    path: indexw4ONCROkyTMeta?.path ?? "/en-in/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-ie",
    path: indexw4ONCROkyTMeta?.path ?? "/en-ie/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-au",
    path: indexw4ONCROkyTMeta?.path ?? "/en-au/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-pa",
    path: indexw4ONCROkyTMeta?.path ?? "/en-pa/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___es-pa",
    path: indexw4ONCROkyTMeta?.path ?? "/es-pa/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-pe",
    path: indexw4ONCROkyTMeta?.path ?? "/en-pe/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___es-pe",
    path: indexw4ONCROkyTMeta?.path ?? "/es-pe/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-pl",
    path: indexw4ONCROkyTMeta?.path ?? "/en-pl/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___pl-pl",
    path: indexw4ONCROkyTMeta?.path ?? "/pl-pl/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-pt",
    path: indexw4ONCROkyTMeta?.path ?? "/en-pt/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___pt-pt",
    path: indexw4ONCROkyTMeta?.path ?? "/pt-pt/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-ro",
    path: indexw4ONCROkyTMeta?.path ?? "/en-ro/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-za",
    path: indexw4ONCROkyTMeta?.path ?? "/en-za/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-ae",
    path: indexw4ONCROkyTMeta?.path ?? "/en-ae/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-sa",
    path: indexw4ONCROkyTMeta?.path ?? "/en-sa/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-om",
    path: indexw4ONCROkyTMeta?.path ?? "/en-om/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-kw",
    path: indexw4ONCROkyTMeta?.path ?? "/en-kw/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-bh",
    path: indexw4ONCROkyTMeta?.path ?? "/en-bh/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-qa",
    path: indexw4ONCROkyTMeta?.path ?? "/en-qa/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-ke",
    path: indexw4ONCROkyTMeta?.path ?? "/en-ke/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexw4ONCROkyTMeta?.name ?? "about-us___en-ng",
    path: indexw4ONCROkyTMeta?.path ?? "/en-ng/about-us",
    meta: indexw4ONCROkyTMeta || {},
    alias: indexw4ONCROkyTMeta?.alias || [],
    redirect: indexw4ONCROkyTMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en",
    path: partnersvx9hifiWVYMeta?.path ?? "/en/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-ca",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-ca/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-co",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-co/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___es-co",
    path: partnersvx9hifiWVYMeta?.path ?? "/es-co/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-cr",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-cr/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___es-cr",
    path: partnersvx9hifiWVYMeta?.path ?? "/es-cr/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-es",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-es/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___es",
    path: partnersvx9hifiWVYMeta?.path ?? "/es/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___es-es",
    path: partnersvx9hifiWVYMeta?.path ?? "/es-es/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-ge",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-ge/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-gb",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-gb/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-us",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-us/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-hk",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-hk/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-hu",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-hu/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___hu-hu",
    path: partnersvx9hifiWVYMeta?.path ?? "/hu-hu/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-in",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-in/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-ie",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-ie/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-au",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-au/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-pa",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-pa/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___es-pa",
    path: partnersvx9hifiWVYMeta?.path ?? "/es-pa/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-pe",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-pe/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___es-pe",
    path: partnersvx9hifiWVYMeta?.path ?? "/es-pe/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-pl",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-pl/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___pl-pl",
    path: partnersvx9hifiWVYMeta?.path ?? "/pl-pl/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-pt",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-pt/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___pt-pt",
    path: partnersvx9hifiWVYMeta?.path ?? "/pt-pt/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-ro",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-ro/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-za",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-za/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-ae",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-ae/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-sa",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-sa/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-om",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-om/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-kw",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-kw/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-bh",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-bh/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-qa",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-qa/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-ke",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-ke/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersvx9hifiWVYMeta?.name ?? "about-us-partners___en-ng",
    path: partnersvx9hifiWVYMeta?.path ?? "/en-ng/about-us/partners",
    meta: partnersvx9hifiWVYMeta || {},
    alias: partnersvx9hifiWVYMeta?.alias || [],
    redirect: partnersvx9hifiWVYMeta?.redirect || undefined,
    component: () => import("/data/pages/about-us/partners.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en",
    path: indexfo5VOb1sbeMeta?.path ?? "/en/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-ca",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-ca/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-co",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-co/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___es-co",
    path: indexfo5VOb1sbeMeta?.path ?? "/es-co/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-cr",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-cr/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___es-cr",
    path: indexfo5VOb1sbeMeta?.path ?? "/es-cr/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-es",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-es/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___es",
    path: indexfo5VOb1sbeMeta?.path ?? "/es/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___es-es",
    path: indexfo5VOb1sbeMeta?.path ?? "/es-es/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-ge",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-ge/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-gb",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-gb/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-us",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-us/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-hk",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-hk/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-hu",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-hu/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___hu-hu",
    path: indexfo5VOb1sbeMeta?.path ?? "/hu-hu/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-in",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-in/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-ie",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-ie/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-au",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-au/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-pa",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-pa/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___es-pa",
    path: indexfo5VOb1sbeMeta?.path ?? "/es-pa/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-pe",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-pe/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___es-pe",
    path: indexfo5VOb1sbeMeta?.path ?? "/es-pe/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-pl",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-pl/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___pl-pl",
    path: indexfo5VOb1sbeMeta?.path ?? "/pl-pl/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-pt",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-pt/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___pt-pt",
    path: indexfo5VOb1sbeMeta?.path ?? "/pt-pt/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-ro",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-ro/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-za",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-za/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-ae",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-ae/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-sa",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-sa/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-om",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-om/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-kw",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-kw/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-bh",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-bh/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-qa",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-qa/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-ke",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-ke/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfo5VOb1sbeMeta?.name ?? "account-page___en-ng",
    path: indexfo5VOb1sbeMeta?.path ?? "/en-ng/account/:page()",
    meta: indexfo5VOb1sbeMeta || {},
    alias: indexfo5VOb1sbeMeta?.alias || [],
    redirect: indexfo5VOb1sbeMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-ca",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-ca/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-co",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-co/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___es-co",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/es-co/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-cr",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-cr/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___es-cr",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/es-cr/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-es",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-es/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___es",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/es/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___es-es",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/es-es/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-ge",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-ge/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-gb",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-gb/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-us",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-us/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-hk",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-hk/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-hu",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-hu/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___hu-hu",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/hu-hu/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-in",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-in/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-ie",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-ie/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-au",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-au/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-pa",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-pa/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___es-pa",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/es-pa/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-pe",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-pe/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___es-pe",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/es-pe/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-pl",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-pl/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___pl-pl",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/pl-pl/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-pt",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-pt/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___pt-pt",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/pt-pt/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-ro",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-ro/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-za",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-za/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-ae",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-ae/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-sa",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-sa/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-om",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-om/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-kw",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-kw/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-bh",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-bh/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-qa",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-qa/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-ke",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-ke/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: account_45cardv0ubeQnsOBMeta?.name ?? "account-page-protected-views-account-settings-components-account-card___en-ng",
    path: account_45cardv0ubeQnsOBMeta?.path ?? "/en-ng/account/:page()/protected/views/account-settings/components/account-card",
    meta: account_45cardv0ubeQnsOBMeta || {},
    alias: account_45cardv0ubeQnsOBMeta?.alias || [],
    redirect: account_45cardv0ubeQnsOBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/components/account-card.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en",
    path: indexlWWDf54wTDMeta?.path ?? "/en/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-ca",
    path: indexlWWDf54wTDMeta?.path ?? "/en-ca/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-co",
    path: indexlWWDf54wTDMeta?.path ?? "/en-co/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___es-co",
    path: indexlWWDf54wTDMeta?.path ?? "/es-co/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-cr",
    path: indexlWWDf54wTDMeta?.path ?? "/en-cr/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___es-cr",
    path: indexlWWDf54wTDMeta?.path ?? "/es-cr/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-es",
    path: indexlWWDf54wTDMeta?.path ?? "/en-es/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___es",
    path: indexlWWDf54wTDMeta?.path ?? "/es/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___es-es",
    path: indexlWWDf54wTDMeta?.path ?? "/es-es/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-ge",
    path: indexlWWDf54wTDMeta?.path ?? "/en-ge/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-gb",
    path: indexlWWDf54wTDMeta?.path ?? "/en-gb/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-us",
    path: indexlWWDf54wTDMeta?.path ?? "/en-us/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-hk",
    path: indexlWWDf54wTDMeta?.path ?? "/en-hk/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-hu",
    path: indexlWWDf54wTDMeta?.path ?? "/en-hu/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___hu-hu",
    path: indexlWWDf54wTDMeta?.path ?? "/hu-hu/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-in",
    path: indexlWWDf54wTDMeta?.path ?? "/en-in/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-ie",
    path: indexlWWDf54wTDMeta?.path ?? "/en-ie/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-au",
    path: indexlWWDf54wTDMeta?.path ?? "/en-au/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-pa",
    path: indexlWWDf54wTDMeta?.path ?? "/en-pa/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___es-pa",
    path: indexlWWDf54wTDMeta?.path ?? "/es-pa/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-pe",
    path: indexlWWDf54wTDMeta?.path ?? "/en-pe/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___es-pe",
    path: indexlWWDf54wTDMeta?.path ?? "/es-pe/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-pl",
    path: indexlWWDf54wTDMeta?.path ?? "/en-pl/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___pl-pl",
    path: indexlWWDf54wTDMeta?.path ?? "/pl-pl/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-pt",
    path: indexlWWDf54wTDMeta?.path ?? "/en-pt/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___pt-pt",
    path: indexlWWDf54wTDMeta?.path ?? "/pt-pt/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-ro",
    path: indexlWWDf54wTDMeta?.path ?? "/en-ro/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-za",
    path: indexlWWDf54wTDMeta?.path ?? "/en-za/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-ae",
    path: indexlWWDf54wTDMeta?.path ?? "/en-ae/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-sa",
    path: indexlWWDf54wTDMeta?.path ?? "/en-sa/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-om",
    path: indexlWWDf54wTDMeta?.path ?? "/en-om/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-kw",
    path: indexlWWDf54wTDMeta?.path ?? "/en-kw/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-bh",
    path: indexlWWDf54wTDMeta?.path ?? "/en-bh/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-qa",
    path: indexlWWDf54wTDMeta?.path ?? "/en-qa/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-ke",
    path: indexlWWDf54wTDMeta?.path ?? "/en-ke/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexlWWDf54wTDMeta?.name ?? "account-page-protected-views-account-settings___en-ng",
    path: indexlWWDf54wTDMeta?.path ?? "/en-ng/account/:page()/protected/views/account-settings",
    meta: indexlWWDf54wTDMeta || {},
    alias: indexlWWDf54wTDMeta?.alias || [],
    redirect: indexlWWDf54wTDMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/index.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-ca",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-ca/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-co",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-co/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___es-co",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/es-co/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-cr",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-cr/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___es-cr",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/es-cr/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-es",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-es/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___es",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/es/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___es-es",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/es-es/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-ge",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-ge/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-gb",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-gb/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-us",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-us/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-hk",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-hk/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-hu",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-hu/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___hu-hu",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/hu-hu/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-in",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-in/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-ie",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-ie/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-au",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-au/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-pa",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-pa/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___es-pa",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/es-pa/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-pe",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-pe/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___es-pe",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/es-pe/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-pl",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-pl/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___pl-pl",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/pl-pl/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-pt",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-pt/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___pt-pt",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/pt-pt/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-ro",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-ro/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-za",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-za/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-ae",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-ae/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-sa",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-sa/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-om",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-om/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-kw",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-kw/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-bh",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-bh/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-qa",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-qa/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-ke",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-ke/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delete_45accountFWElTUQQYpMeta?.name ?? "account-page-protected-views-account-settings-sections-delete-account___en-ng",
    path: delete_45accountFWElTUQQYpMeta?.path ?? "/en-ng/account/:page()/protected/views/account-settings/sections/delete-account",
    meta: delete_45accountFWElTUQQYpMeta || {},
    alias: delete_45accountFWElTUQQYpMeta?.alias || [],
    redirect: delete_45accountFWElTUQQYpMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delete-account.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-ca",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-ca/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-co",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-co/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___es-co",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/es-co/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-cr",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-cr/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___es-cr",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/es-cr/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-es",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-es/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___es",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/es/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___es-es",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/es-es/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-ge",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-ge/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-gb",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-gb/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-us",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-us/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-hk",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-hk/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-hu",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-hu/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___hu-hu",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/hu-hu/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-in",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-in/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-ie",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-ie/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-au",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-au/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-pa",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-pa/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___es-pa",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/es-pa/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-pe",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-pe/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___es-pe",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/es-pe/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-pl",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-pl/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___pl-pl",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/pl-pl/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-pt",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-pt/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___pt-pt",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/pt-pt/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-ro",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-ro/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-za",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-za/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-ae",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-ae/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-sa",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-sa/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-om",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-om/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-kw",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-kw/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-bh",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-bh/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-qa",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-qa/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-ke",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-ke/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: delivery_45addressp3W0d1NjonMeta?.name ?? "account-page-protected-views-account-settings-sections-delivery-address___en-ng",
    path: delivery_45addressp3W0d1NjonMeta?.path ?? "/en-ng/account/:page()/protected/views/account-settings/sections/delivery-address",
    meta: delivery_45addressp3W0d1NjonMeta || {},
    alias: delivery_45addressp3W0d1NjonMeta?.alias || [],
    redirect: delivery_45addressp3W0d1NjonMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/delivery-address.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en",
    path: emaildPRsz9lcXNMeta?.path ?? "/en/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-ca",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-ca/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-co",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-co/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___es-co",
    path: emaildPRsz9lcXNMeta?.path ?? "/es-co/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-cr",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-cr/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___es-cr",
    path: emaildPRsz9lcXNMeta?.path ?? "/es-cr/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-es",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-es/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___es",
    path: emaildPRsz9lcXNMeta?.path ?? "/es/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___es-es",
    path: emaildPRsz9lcXNMeta?.path ?? "/es-es/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-ge",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-ge/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-gb",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-gb/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-us",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-us/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-hk",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-hk/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-hu",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-hu/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___hu-hu",
    path: emaildPRsz9lcXNMeta?.path ?? "/hu-hu/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-in",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-in/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-ie",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-ie/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-au",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-au/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-pa",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-pa/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___es-pa",
    path: emaildPRsz9lcXNMeta?.path ?? "/es-pa/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-pe",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-pe/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___es-pe",
    path: emaildPRsz9lcXNMeta?.path ?? "/es-pe/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-pl",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-pl/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___pl-pl",
    path: emaildPRsz9lcXNMeta?.path ?? "/pl-pl/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-pt",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-pt/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___pt-pt",
    path: emaildPRsz9lcXNMeta?.path ?? "/pt-pt/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-ro",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-ro/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-za",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-za/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-ae",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-ae/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-sa",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-sa/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-om",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-om/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-kw",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-kw/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-bh",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-bh/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-qa",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-qa/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-ke",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-ke/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: emaildPRsz9lcXNMeta?.name ?? "account-page-protected-views-account-settings-sections-email___en-ng",
    path: emaildPRsz9lcXNMeta?.path ?? "/en-ng/account/:page()/protected/views/account-settings/sections/email",
    meta: emaildPRsz9lcXNMeta || {},
    alias: emaildPRsz9lcXNMeta?.alias || [],
    redirect: emaildPRsz9lcXNMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/email.vue").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en",
    path: indexopwKIz2VbqMeta?.path ?? "/en/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-ca",
    path: indexopwKIz2VbqMeta?.path ?? "/en-ca/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-co",
    path: indexopwKIz2VbqMeta?.path ?? "/en-co/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___es-co",
    path: indexopwKIz2VbqMeta?.path ?? "/es-co/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-cr",
    path: indexopwKIz2VbqMeta?.path ?? "/en-cr/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___es-cr",
    path: indexopwKIz2VbqMeta?.path ?? "/es-cr/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-es",
    path: indexopwKIz2VbqMeta?.path ?? "/en-es/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___es",
    path: indexopwKIz2VbqMeta?.path ?? "/es/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___es-es",
    path: indexopwKIz2VbqMeta?.path ?? "/es-es/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-ge",
    path: indexopwKIz2VbqMeta?.path ?? "/en-ge/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-gb",
    path: indexopwKIz2VbqMeta?.path ?? "/en-gb/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-us",
    path: indexopwKIz2VbqMeta?.path ?? "/en-us/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-hk",
    path: indexopwKIz2VbqMeta?.path ?? "/en-hk/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-hu",
    path: indexopwKIz2VbqMeta?.path ?? "/en-hu/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___hu-hu",
    path: indexopwKIz2VbqMeta?.path ?? "/hu-hu/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-in",
    path: indexopwKIz2VbqMeta?.path ?? "/en-in/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-ie",
    path: indexopwKIz2VbqMeta?.path ?? "/en-ie/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-au",
    path: indexopwKIz2VbqMeta?.path ?? "/en-au/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-pa",
    path: indexopwKIz2VbqMeta?.path ?? "/en-pa/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___es-pa",
    path: indexopwKIz2VbqMeta?.path ?? "/es-pa/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-pe",
    path: indexopwKIz2VbqMeta?.path ?? "/en-pe/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___es-pe",
    path: indexopwKIz2VbqMeta?.path ?? "/es-pe/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-pl",
    path: indexopwKIz2VbqMeta?.path ?? "/en-pl/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___pl-pl",
    path: indexopwKIz2VbqMeta?.path ?? "/pl-pl/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-pt",
    path: indexopwKIz2VbqMeta?.path ?? "/en-pt/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___pt-pt",
    path: indexopwKIz2VbqMeta?.path ?? "/pt-pt/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-ro",
    path: indexopwKIz2VbqMeta?.path ?? "/en-ro/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-za",
    path: indexopwKIz2VbqMeta?.path ?? "/en-za/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-ae",
    path: indexopwKIz2VbqMeta?.path ?? "/en-ae/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-sa",
    path: indexopwKIz2VbqMeta?.path ?? "/en-sa/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-om",
    path: indexopwKIz2VbqMeta?.path ?? "/en-om/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-kw",
    path: indexopwKIz2VbqMeta?.path ?? "/en-kw/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-bh",
    path: indexopwKIz2VbqMeta?.path ?? "/en-bh/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-qa",
    path: indexopwKIz2VbqMeta?.path ?? "/en-qa/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-ke",
    path: indexopwKIz2VbqMeta?.path ?? "/en-ke/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: indexopwKIz2VbqMeta?.name ?? "account-page-protected-views-account-settings-sections___en-ng",
    path: indexopwKIz2VbqMeta?.path ?? "/en-ng/account/:page()/protected/views/account-settings/sections",
    meta: indexopwKIz2VbqMeta || {},
    alias: indexopwKIz2VbqMeta?.alias || [],
    redirect: indexopwKIz2VbqMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/index.ts").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-ca",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-ca/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-co",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-co/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___es-co",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/es-co/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-cr",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-cr/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___es-cr",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/es-cr/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-es",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-es/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___es",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/es/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___es-es",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/es-es/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-ge",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-ge/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-gb",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-gb/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-us",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-us/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-hk",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-hk/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-hu",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-hu/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___hu-hu",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/hu-hu/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-in",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-in/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-ie",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-ie/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-au",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-au/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-pa",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-pa/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___es-pa",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/es-pa/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-pe",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-pe/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___es-pe",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/es-pe/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-pl",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-pl/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___pl-pl",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/pl-pl/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-pt",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-pt/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___pt-pt",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/pt-pt/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-ro",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-ro/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-za",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-za/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-ae",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-ae/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-sa",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-sa/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-om",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-om/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-kw",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-kw/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-bh",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-bh/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-qa",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-qa/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-ke",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-ke/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: new_45emailqb16V6BaG6Meta?.name ?? "account-page-protected-views-account-settings-sections-new-email___en-ng",
    path: new_45emailqb16V6BaG6Meta?.path ?? "/en-ng/account/:page()/protected/views/account-settings/sections/new-email",
    meta: new_45emailqb16V6BaG6Meta || {},
    alias: new_45emailqb16V6BaG6Meta?.alias || [],
    redirect: new_45emailqb16V6BaG6Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/new-email.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en",
    path: password7pYgeVy1fMMeta?.path ?? "/en/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-ca",
    path: password7pYgeVy1fMMeta?.path ?? "/en-ca/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-co",
    path: password7pYgeVy1fMMeta?.path ?? "/en-co/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___es-co",
    path: password7pYgeVy1fMMeta?.path ?? "/es-co/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-cr",
    path: password7pYgeVy1fMMeta?.path ?? "/en-cr/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___es-cr",
    path: password7pYgeVy1fMMeta?.path ?? "/es-cr/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-es",
    path: password7pYgeVy1fMMeta?.path ?? "/en-es/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___es",
    path: password7pYgeVy1fMMeta?.path ?? "/es/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___es-es",
    path: password7pYgeVy1fMMeta?.path ?? "/es-es/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-ge",
    path: password7pYgeVy1fMMeta?.path ?? "/en-ge/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-gb",
    path: password7pYgeVy1fMMeta?.path ?? "/en-gb/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-us",
    path: password7pYgeVy1fMMeta?.path ?? "/en-us/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-hk",
    path: password7pYgeVy1fMMeta?.path ?? "/en-hk/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-hu",
    path: password7pYgeVy1fMMeta?.path ?? "/en-hu/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___hu-hu",
    path: password7pYgeVy1fMMeta?.path ?? "/hu-hu/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-in",
    path: password7pYgeVy1fMMeta?.path ?? "/en-in/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-ie",
    path: password7pYgeVy1fMMeta?.path ?? "/en-ie/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-au",
    path: password7pYgeVy1fMMeta?.path ?? "/en-au/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-pa",
    path: password7pYgeVy1fMMeta?.path ?? "/en-pa/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___es-pa",
    path: password7pYgeVy1fMMeta?.path ?? "/es-pa/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-pe",
    path: password7pYgeVy1fMMeta?.path ?? "/en-pe/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___es-pe",
    path: password7pYgeVy1fMMeta?.path ?? "/es-pe/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-pl",
    path: password7pYgeVy1fMMeta?.path ?? "/en-pl/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___pl-pl",
    path: password7pYgeVy1fMMeta?.path ?? "/pl-pl/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-pt",
    path: password7pYgeVy1fMMeta?.path ?? "/en-pt/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___pt-pt",
    path: password7pYgeVy1fMMeta?.path ?? "/pt-pt/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-ro",
    path: password7pYgeVy1fMMeta?.path ?? "/en-ro/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-za",
    path: password7pYgeVy1fMMeta?.path ?? "/en-za/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-ae",
    path: password7pYgeVy1fMMeta?.path ?? "/en-ae/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-sa",
    path: password7pYgeVy1fMMeta?.path ?? "/en-sa/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-om",
    path: password7pYgeVy1fMMeta?.path ?? "/en-om/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-kw",
    path: password7pYgeVy1fMMeta?.path ?? "/en-kw/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-bh",
    path: password7pYgeVy1fMMeta?.path ?? "/en-bh/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-qa",
    path: password7pYgeVy1fMMeta?.path ?? "/en-qa/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-ke",
    path: password7pYgeVy1fMMeta?.path ?? "/en-ke/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: password7pYgeVy1fMMeta?.name ?? "account-page-protected-views-account-settings-sections-password___en-ng",
    path: password7pYgeVy1fMMeta?.path ?? "/en-ng/account/:page()/protected/views/account-settings/sections/password",
    meta: password7pYgeVy1fMMeta || {},
    alias: password7pYgeVy1fMMeta?.alias || [],
    redirect: password7pYgeVy1fMMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/password.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-ca",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-ca/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-co",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-co/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___es-co",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/es-co/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-cr",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-cr/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___es-cr",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/es-cr/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-es",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-es/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___es",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/es/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___es-es",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/es-es/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-ge",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-ge/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-gb",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-gb/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-us",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-us/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-hk",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-hk/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-hu",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-hu/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___hu-hu",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/hu-hu/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-in",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-in/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-ie",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-ie/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-au",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-au/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-pa",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-pa/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___es-pa",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/es-pa/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-pe",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-pe/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___es-pe",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/es-pe/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-pl",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-pl/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___pl-pl",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/pl-pl/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-pt",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-pt/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___pt-pt",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/pt-pt/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-ro",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-ro/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-za",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-za/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-ae",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-ae/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-sa",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-sa/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-om",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-om/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-kw",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-kw/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-bh",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-bh/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-qa",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-qa/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-ke",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-ke/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: personal_45detailsqBwHqe4JkdMeta?.name ?? "account-page-protected-views-account-settings-sections-personal-details___en-ng",
    path: personal_45detailsqBwHqe4JkdMeta?.path ?? "/en-ng/account/:page()/protected/views/account-settings/sections/personal-details",
    meta: personal_45detailsqBwHqe4JkdMeta || {},
    alias: personal_45detailsqBwHqe4JkdMeta?.alias || [],
    redirect: personal_45detailsqBwHqe4JkdMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/personal-details.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-ca",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-ca/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-co",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-co/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___es-co",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/es-co/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-cr",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-cr/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___es-cr",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/es-cr/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-es",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-es/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___es",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/es/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___es-es",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/es-es/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-ge",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-ge/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-gb",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-gb/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-us",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-us/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-hk",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-hk/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-hu",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-hu/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___hu-hu",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/hu-hu/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-in",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-in/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-ie",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-ie/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-au",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-au/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-pa",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-pa/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___es-pa",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/es-pa/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-pe",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-pe/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___es-pe",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/es-pe/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-pl",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-pl/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___pl-pl",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/pl-pl/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-pt",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-pt/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___pt-pt",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/pt-pt/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-ro",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-ro/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-za",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-za/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-ae",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-ae/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-sa",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-sa/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-om",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-om/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-kw",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-kw/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-bh",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-bh/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-qa",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-qa/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-ke",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-ke/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: phone_45numberElsv4wwgmBMeta?.name ?? "account-page-protected-views-account-settings-sections-phone-number___en-ng",
    path: phone_45numberElsv4wwgmBMeta?.path ?? "/en-ng/account/:page()/protected/views/account-settings/sections/phone-number",
    meta: phone_45numberElsv4wwgmBMeta || {},
    alias: phone_45numberElsv4wwgmBMeta?.alias || [],
    redirect: phone_45numberElsv4wwgmBMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/account-settings/sections/phone-number.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-ca",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-ca/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-co",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-co/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___es-co",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/es-co/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-cr",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-cr/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___es-cr",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/es-cr/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-es",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-es/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___es",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/es/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___es-es",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/es-es/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-ge",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-ge/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-gb",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-gb/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-us",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-us/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-hk",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-hk/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-hu",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-hu/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___hu-hu",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/hu-hu/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-in",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-in/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-ie",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-ie/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-au",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-au/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-pa",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-pa/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___es-pa",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/es-pa/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-pe",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-pe/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___es-pe",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/es-pe/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-pl",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-pl/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___pl-pl",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/pl-pl/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-pt",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-pt/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___pt-pt",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/pt-pt/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-ro",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-ro/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-za",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-za/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-ae",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-ae/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-sa",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-sa/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-om",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-om/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-kw",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-kw/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-bh",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-bh/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-qa",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-qa/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-ke",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-ke/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutdsr9bcVHE4Meta?.name ?? "account-page-protected-views-order-history-components-device-signout___en-ng",
    path: device_45signoutdsr9bcVHE4Meta?.path ?? "/en-ng/account/:page()/protected/views/order-history/components/device-signout",
    meta: device_45signoutdsr9bcVHE4Meta || {},
    alias: device_45signoutdsr9bcVHE4Meta?.alias || [],
    redirect: device_45signoutdsr9bcVHE4Meta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-ca",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-ca/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-co",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-co/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___es-co",
    path: indexRd1ZMxNn5bMeta?.path ?? "/es-co/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-cr",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-cr/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___es-cr",
    path: indexRd1ZMxNn5bMeta?.path ?? "/es-cr/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-es",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-es/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___es",
    path: indexRd1ZMxNn5bMeta?.path ?? "/es/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___es-es",
    path: indexRd1ZMxNn5bMeta?.path ?? "/es-es/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-ge",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-ge/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-gb",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-gb/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-us",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-us/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-hk",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-hk/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-hu",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-hu/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___hu-hu",
    path: indexRd1ZMxNn5bMeta?.path ?? "/hu-hu/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-in",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-in/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-ie",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-ie/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-au",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-au/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-pa",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-pa/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___es-pa",
    path: indexRd1ZMxNn5bMeta?.path ?? "/es-pa/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-pe",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-pe/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___es-pe",
    path: indexRd1ZMxNn5bMeta?.path ?? "/es-pe/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-pl",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-pl/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___pl-pl",
    path: indexRd1ZMxNn5bMeta?.path ?? "/pl-pl/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-pt",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-pt/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___pt-pt",
    path: indexRd1ZMxNn5bMeta?.path ?? "/pt-pt/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-ro",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-ro/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-za",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-za/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-ae",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-ae/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-sa",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-sa/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-om",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-om/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-kw",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-kw/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-bh",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-bh/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-qa",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-qa/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-ke",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-ke/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexRd1ZMxNn5bMeta?.name ?? "account-page-protected-views-order-history___en-ng",
    path: indexRd1ZMxNn5bMeta?.path ?? "/en-ng/account/:page()/protected/views/order-history",
    meta: indexRd1ZMxNn5bMeta || {},
    alias: indexRd1ZMxNn5bMeta?.alias || [],
    redirect: indexRd1ZMxNn5bMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/order-history/index.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-ca",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-ca/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-co",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-co/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___es-co",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/es-co/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-cr",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-cr/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___es-cr",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/es-cr/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-es",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-es/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___es",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/es/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___es-es",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/es-es/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-ge",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-ge/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-gb",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-gb/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-us",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-us/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-hk",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-hk/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-hu",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-hu/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___hu-hu",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/hu-hu/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-in",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-in/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-ie",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-ie/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-au",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-au/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-pa",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-pa/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___es-pa",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/es-pa/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-pe",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-pe/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___es-pe",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/es-pe/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-pl",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-pl/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___pl-pl",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/pl-pl/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-pt",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-pt/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___pt-pt",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/pt-pt/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-ro",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-ro/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-za",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-za/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-ae",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-ae/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-sa",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-sa/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-om",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-om/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-kw",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-kw/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-bh",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-bh/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-qa",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-qa/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-ke",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-ke/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: device_45signoutEa8ed5ZbwHMeta?.name ?? "account-page-protected-views-security-components-device-signout___en-ng",
    path: device_45signoutEa8ed5ZbwHMeta?.path ?? "/en-ng/account/:page()/protected/views/security/components/device-signout",
    meta: device_45signoutEa8ed5ZbwHMeta || {},
    alias: device_45signoutEa8ed5ZbwHMeta?.alias || [],
    redirect: device_45signoutEa8ed5ZbwHMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/components/device-signout.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en",
    path: indexz1wzNUfIjJMeta?.path ?? "/en/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-ca",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-ca/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-co",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-co/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___es-co",
    path: indexz1wzNUfIjJMeta?.path ?? "/es-co/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-cr",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-cr/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___es-cr",
    path: indexz1wzNUfIjJMeta?.path ?? "/es-cr/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-es",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-es/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___es",
    path: indexz1wzNUfIjJMeta?.path ?? "/es/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___es-es",
    path: indexz1wzNUfIjJMeta?.path ?? "/es-es/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-ge",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-ge/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-gb",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-gb/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-us",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-us/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-hk",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-hk/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-hu",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-hu/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___hu-hu",
    path: indexz1wzNUfIjJMeta?.path ?? "/hu-hu/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-in",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-in/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-ie",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-ie/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-au",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-au/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-pa",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-pa/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___es-pa",
    path: indexz1wzNUfIjJMeta?.path ?? "/es-pa/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-pe",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-pe/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___es-pe",
    path: indexz1wzNUfIjJMeta?.path ?? "/es-pe/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-pl",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-pl/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___pl-pl",
    path: indexz1wzNUfIjJMeta?.path ?? "/pl-pl/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-pt",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-pt/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___pt-pt",
    path: indexz1wzNUfIjJMeta?.path ?? "/pt-pt/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-ro",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-ro/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-za",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-za/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-ae",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-ae/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-sa",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-sa/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-om",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-om/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-kw",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-kw/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-bh",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-bh/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-qa",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-qa/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-ke",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-ke/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: indexz1wzNUfIjJMeta?.name ?? "account-page-protected-views-security___en-ng",
    path: indexz1wzNUfIjJMeta?.path ?? "/en-ng/account/:page()/protected/views/security",
    meta: indexz1wzNUfIjJMeta || {},
    alias: indexz1wzNUfIjJMeta?.alias || [],
    redirect: indexz1wzNUfIjJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/protected/views/security/index.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-ca",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-ca/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-co",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-co/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___es-co",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/es-co/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-cr",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-cr/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___es-cr",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/es-cr/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-es",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-es/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___es",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/es/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___es-es",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/es-es/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-ge",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-ge/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-gb",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-gb/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-us",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-us/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-hk",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-hk/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-hu",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-hu/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___hu-hu",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/hu-hu/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-in",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-in/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-ie",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-ie/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-au",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-au/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-pa",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-pa/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___es-pa",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/es-pa/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-pe",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-pe/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___es-pe",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/es-pe/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-pl",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-pl/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___pl-pl",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/pl-pl/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-pt",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-pt/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___pt-pt",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/pt-pt/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-ro",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-ro/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-za",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-za/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-ae",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-ae/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-sa",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-sa/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-om",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-om/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-kw",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-kw/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-bh",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-bh/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-qa",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-qa/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-ke",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-ke/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45containerUm5Lrhj0IwMeta?.name ?? "account-page-public-components-auth-container___en-ng",
    path: auth_45containerUm5Lrhj0IwMeta?.path ?? "/en-ng/account/:page()/public/components/auth-container",
    meta: auth_45containerUm5Lrhj0IwMeta || {},
    alias: auth_45containerUm5Lrhj0IwMeta?.alias || [],
    redirect: auth_45containerUm5Lrhj0IwMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-container.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-ca",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-ca/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-co",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-co/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___es-co",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/es-co/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-cr",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-cr/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___es-cr",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/es-cr/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-es",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-es/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___es",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/es/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___es-es",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/es-es/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-ge",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-ge/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-gb",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-gb/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-us",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-us/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-hk",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-hk/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-hu",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-hu/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___hu-hu",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/hu-hu/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-in",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-in/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-ie",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-ie/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-au",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-au/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-pa",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-pa/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___es-pa",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/es-pa/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-pe",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-pe/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___es-pe",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/es-pe/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-pl",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-pl/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___pl-pl",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/pl-pl/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-pt",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-pt/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___pt-pt",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/pt-pt/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-ro",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-ro/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-za",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-za/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-ae",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-ae/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-sa",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-sa/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-om",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-om/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-kw",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-kw/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-bh",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-bh/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-qa",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-qa/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-ke",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-ke/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: auth_45windowzXElIeYSiiMeta?.name ?? "account-page-public-components-auth-window___en-ng",
    path: auth_45windowzXElIeYSiiMeta?.path ?? "/en-ng/account/:page()/public/components/auth-window",
    meta: auth_45windowzXElIeYSiiMeta || {},
    alias: auth_45windowzXElIeYSiiMeta?.alias || [],
    redirect: auth_45windowzXElIeYSiiMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/auth-window.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-ca",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-ca/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-co",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-co/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___es-co",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/es-co/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-cr",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-cr/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___es-cr",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/es-cr/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-es",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-es/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___es",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/es/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___es-es",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/es-es/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-ge",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-ge/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-gb",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-gb/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-us",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-us/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-hk",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-hk/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-hu",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-hu/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___hu-hu",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/hu-hu/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-in",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-in/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-ie",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-ie/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-au",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-au/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-pa",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-pa/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___es-pa",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/es-pa/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-pe",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-pe/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___es-pe",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/es-pe/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-pl",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-pl/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___pl-pl",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/pl-pl/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-pt",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-pt/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___pt-pt",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/pt-pt/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-ro",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-ro/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-za",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-za/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-ae",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-ae/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-sa",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-sa/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-om",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-om/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-kw",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-kw/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-bh",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-bh/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-qa",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-qa/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-ke",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-ke/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: page_45headerwWpL8Krq7tMeta?.name ?? "account-page-public-components-page-header___en-ng",
    path: page_45headerwWpL8Krq7tMeta?.path ?? "/en-ng/account/:page()/public/components/page-header",
    meta: page_45headerwWpL8Krq7tMeta || {},
    alias: page_45headerwWpL8Krq7tMeta?.alias || [],
    redirect: page_45headerwWpL8Krq7tMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/components/page-header.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en",
    path: loginkkIGVYMbBJMeta?.path ?? "/en/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-ca",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-ca/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-co",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-co/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___es-co",
    path: loginkkIGVYMbBJMeta?.path ?? "/es-co/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-cr",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-cr/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___es-cr",
    path: loginkkIGVYMbBJMeta?.path ?? "/es-cr/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-es",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-es/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___es",
    path: loginkkIGVYMbBJMeta?.path ?? "/es/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___es-es",
    path: loginkkIGVYMbBJMeta?.path ?? "/es-es/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-ge",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-ge/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-gb",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-gb/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-us",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-us/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-hk",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-hk/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-hu",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-hu/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___hu-hu",
    path: loginkkIGVYMbBJMeta?.path ?? "/hu-hu/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-in",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-in/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-ie",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-ie/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-au",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-au/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-pa",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-pa/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___es-pa",
    path: loginkkIGVYMbBJMeta?.path ?? "/es-pa/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-pe",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-pe/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___es-pe",
    path: loginkkIGVYMbBJMeta?.path ?? "/es-pe/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-pl",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-pl/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___pl-pl",
    path: loginkkIGVYMbBJMeta?.path ?? "/pl-pl/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-pt",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-pt/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___pt-pt",
    path: loginkkIGVYMbBJMeta?.path ?? "/pt-pt/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-ro",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-ro/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-za",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-za/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-ae",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-ae/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-sa",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-sa/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-om",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-om/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-kw",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-kw/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-bh",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-bh/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-qa",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-qa/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-ke",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-ke/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: loginkkIGVYMbBJMeta?.name ?? "account-page-public-views-login___en-ng",
    path: loginkkIGVYMbBJMeta?.path ?? "/en-ng/account/:page()/public/views/login",
    meta: loginkkIGVYMbBJMeta || {},
    alias: loginkkIGVYMbBJMeta?.alias || [],
    redirect: loginkkIGVYMbBJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/login.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-ca",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-ca/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-co",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-co/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___es-co",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/es-co/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-cr",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-cr/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___es-cr",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/es-cr/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-es",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-es/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___es",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/es/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___es-es",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/es-es/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-ge",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-ge/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-gb",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-gb/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-us",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-us/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-hk",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-hk/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-hu",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-hu/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___hu-hu",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/hu-hu/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-in",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-in/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-ie",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-ie/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-au",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-au/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-pa",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-pa/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___es-pa",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/es-pa/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-pe",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-pe/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___es-pe",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/es-pe/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-pl",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-pl/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___pl-pl",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/pl-pl/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-pt",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-pt/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___pt-pt",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/pt-pt/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-ro",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-ro/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-za",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-za/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-ae",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-ae/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-sa",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-sa/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-om",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-om/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-kw",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-kw/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-bh",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-bh/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-qa",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-qa/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-ke",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-ke/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: password_45resetLMIFhG83YJMeta?.name ?? "account-page-public-views-password-reset___en-ng",
    path: password_45resetLMIFhG83YJMeta?.path ?? "/en-ng/account/:page()/public/views/password-reset",
    meta: password_45resetLMIFhG83YJMeta || {},
    alias: password_45resetLMIFhG83YJMeta?.alias || [],
    redirect: password_45resetLMIFhG83YJMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/password-reset.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-ca",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-ca/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-co",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-co/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___es-co",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/es-co/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-cr",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-cr/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___es-cr",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/es-cr/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-es",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-es/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___es",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/es/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___es-es",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/es-es/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-ge",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-ge/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-gb",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-gb/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-us",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-us/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-hk",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-hk/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-hu",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-hu/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___hu-hu",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/hu-hu/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-in",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-in/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-ie",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-ie/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-au",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-au/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-pa",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-pa/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___es-pa",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/es-pa/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-pe",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-pe/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___es-pe",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/es-pe/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-pl",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-pl/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___pl-pl",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/pl-pl/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-pt",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-pt/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___pt-pt",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/pt-pt/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-ro",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-ro/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-za",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-za/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-ae",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-ae/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-sa",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-sa/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-om",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-om/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-kw",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-kw/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-bh",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-bh/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-qa",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-qa/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-ke",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-ke/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45password9XiWnOvvWVMeta?.name ?? "account-page-public-views-reset-password___en-ng",
    path: reset_45password9XiWnOvvWVMeta?.path ?? "/en-ng/account/:page()/public/views/reset-password",
    meta: reset_45password9XiWnOvvWVMeta || {},
    alias: reset_45password9XiWnOvvWVMeta?.alias || [],
    redirect: reset_45password9XiWnOvvWVMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/reset-password.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en",
    path: signupU5jtSSJqIRMeta?.path ?? "/en/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-ca",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-ca/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-co",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-co/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___es-co",
    path: signupU5jtSSJqIRMeta?.path ?? "/es-co/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-cr",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-cr/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___es-cr",
    path: signupU5jtSSJqIRMeta?.path ?? "/es-cr/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-es",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-es/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___es",
    path: signupU5jtSSJqIRMeta?.path ?? "/es/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___es-es",
    path: signupU5jtSSJqIRMeta?.path ?? "/es-es/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-ge",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-ge/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-gb",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-gb/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-us",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-us/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-hk",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-hk/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-hu",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-hu/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___hu-hu",
    path: signupU5jtSSJqIRMeta?.path ?? "/hu-hu/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-in",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-in/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-ie",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-ie/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-au",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-au/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-pa",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-pa/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___es-pa",
    path: signupU5jtSSJqIRMeta?.path ?? "/es-pa/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-pe",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-pe/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___es-pe",
    path: signupU5jtSSJqIRMeta?.path ?? "/es-pe/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-pl",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-pl/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___pl-pl",
    path: signupU5jtSSJqIRMeta?.path ?? "/pl-pl/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-pt",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-pt/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___pt-pt",
    path: signupU5jtSSJqIRMeta?.path ?? "/pt-pt/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-ro",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-ro/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-za",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-za/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-ae",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-ae/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-sa",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-sa/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-om",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-om/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-kw",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-kw/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-bh",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-bh/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-qa",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-qa/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-ke",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-ke/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: signupU5jtSSJqIRMeta?.name ?? "account-page-public-views-signup___en-ng",
    path: signupU5jtSSJqIRMeta?.path ?? "/en-ng/account/:page()/public/views/signup",
    meta: signupU5jtSSJqIRMeta || {},
    alias: signupU5jtSSJqIRMeta?.alias || [],
    redirect: signupU5jtSSJqIRMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/signup.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-ca",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-ca/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-co",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-co/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___es-co",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/es-co/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-cr",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-cr/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___es-cr",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/es-cr/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-es",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-es/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___es",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/es/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___es-es",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/es-es/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-ge",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-ge/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-gb",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-gb/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-us",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-us/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-hk",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-hk/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-hu",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-hu/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___hu-hu",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/hu-hu/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-in",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-in/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-ie",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-ie/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-au",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-au/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-pa",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-pa/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___es-pa",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/es-pa/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-pe",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-pe/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___es-pe",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/es-pe/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-pl",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-pl/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___pl-pl",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/pl-pl/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-pt",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-pt/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___pt-pt",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/pt-pt/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-ro",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-ro/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-za",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-za/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-ae",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-ae/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-sa",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-sa/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-om",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-om/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-kw",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-kw/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-bh",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-bh/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-qa",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-qa/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-ke",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-ke/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailkXhkmHueRWMeta?.name ?? "account-page-public-views-verify-email___en-ng",
    path: verify_45emailkXhkmHueRWMeta?.path ?? "/en-ng/account/:page()/public/views/verify-email",
    meta: verify_45emailkXhkmHueRWMeta || {},
    alias: verify_45emailkXhkmHueRWMeta?.alias || [],
    redirect: verify_45emailkXhkmHueRWMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-ca",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-ca/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-co",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-co/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___es-co",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/es-co/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-cr",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-cr/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___es-cr",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/es-cr/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-es",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-es/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___es",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/es/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___es-es",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/es-es/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-ge",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-ge/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-gb",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-gb/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-us",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-us/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-hk",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-hk/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-hu",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-hu/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___hu-hu",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/hu-hu/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-in",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-in/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-ie",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-ie/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-au",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-au/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-pa",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-pa/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___es-pa",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/es-pa/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-pe",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-pe/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___es-pe",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/es-pe/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-pl",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-pl/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___pl-pl",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/pl-pl/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-pt",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-pt/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___pt-pt",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/pt-pt/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-ro",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-ro/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-za",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-za/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-ae",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-ae/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-sa",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-sa/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-om",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-om/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-kw",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-kw/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-bh",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-bh/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-qa",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-qa/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-ke",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-ke/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45updated_45email6k3D7ouiQXMeta?.name ?? "account-page-public-views-verify-updated-email___en-ng",
    path: verify_45updated_45email6k3D7ouiQXMeta?.path ?? "/en-ng/account/:page()/public/views/verify-updated-email",
    meta: verify_45updated_45email6k3D7ouiQXMeta || {},
    alias: verify_45updated_45email6k3D7ouiQXMeta?.alias || [],
    redirect: verify_45updated_45email6k3D7ouiQXMeta?.redirect || undefined,
    component: () => import("/data/pages/account/[page]/public/views/verify-updated-email.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-ca",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-ca/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-co",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-co/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___es-co",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/es-co/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-cr",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-cr/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___es-cr",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/es-cr/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-es",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-es/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___es",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/es/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___es-es",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/es-es/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-ge",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-ge/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-gb",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-gb/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-us",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-us/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-hk",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-hk/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-hu",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-hu/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___hu-hu",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/hu-hu/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-in",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-in/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-ie",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-ie/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-au",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-au/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-pa",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-pa/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___es-pa",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/es-pa/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-pe",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-pe/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___es-pe",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/es-pe/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-pl",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-pl/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___pl-pl",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/pl-pl/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-pt",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-pt/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___pt-pt",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/pt-pt/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-ro",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-ro/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-za",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-za/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-ae",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-ae/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-sa",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-sa/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-om",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-om/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-kw",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-kw/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-bh",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-bh/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-qa",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-qa/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-ke",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-ke/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: dashboard_45cardy8jkOjeVcjMeta?.name ?? "account-components-dashboard-card___en-ng",
    path: dashboard_45cardy8jkOjeVcjMeta?.path ?? "/en-ng/account/components/dashboard-card",
    meta: dashboard_45cardy8jkOjeVcjMeta || {},
    alias: dashboard_45cardy8jkOjeVcjMeta?.alias || [],
    redirect: dashboard_45cardy8jkOjeVcjMeta?.redirect || undefined,
    component: () => import("/data/pages/account/components/dashboard-card.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-ca",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-ca/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-co",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-co/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___es-co",
    path: indexX6Tsj9kTOCMeta?.path ?? "/es-co/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-cr",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-cr/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___es-cr",
    path: indexX6Tsj9kTOCMeta?.path ?? "/es-cr/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-es",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-es/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___es",
    path: indexX6Tsj9kTOCMeta?.path ?? "/es/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___es-es",
    path: indexX6Tsj9kTOCMeta?.path ?? "/es-es/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-ge",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-ge/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-gb",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-gb/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-us",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-us/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-hk",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-hk/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-hu",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-hu/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___hu-hu",
    path: indexX6Tsj9kTOCMeta?.path ?? "/hu-hu/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-in",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-in/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-ie",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-ie/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-au",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-au/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-pa",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-pa/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___es-pa",
    path: indexX6Tsj9kTOCMeta?.path ?? "/es-pa/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-pe",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-pe/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___es-pe",
    path: indexX6Tsj9kTOCMeta?.path ?? "/es-pe/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-pl",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-pl/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___pl-pl",
    path: indexX6Tsj9kTOCMeta?.path ?? "/pl-pl/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-pt",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-pt/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___pt-pt",
    path: indexX6Tsj9kTOCMeta?.path ?? "/pt-pt/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-ro",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-ro/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-za",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-za/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-ae",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-ae/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-sa",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-sa/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-om",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-om/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-kw",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-kw/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-bh",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-bh/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-qa",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-qa/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-ke",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-ke/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6Tsj9kTOCMeta?.name ?? "account___en-ng",
    path: indexX6Tsj9kTOCMeta?.path ?? "/en-ng/account",
    meta: indexX6Tsj9kTOCMeta || {},
    alias: indexX6Tsj9kTOCMeta?.alias || [],
    redirect: indexX6Tsj9kTOCMeta?.redirect || undefined,
    component: () => import("/data/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93cXioxiEr7bMeta?.name ?? "blog-slug___en",
    path: _91slug_93cXioxiEr7bMeta?.path ?? "/en/blog/:slug()",
    meta: _91slug_93cXioxiEr7bMeta || {},
    alias: _91slug_93cXioxiEr7bMeta?.alias || [],
    redirect: _91slug_93cXioxiEr7bMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93cXioxiEr7bMeta?.name ?? "blog-slug___es",
    path: _91slug_93cXioxiEr7bMeta?.path ?? "/es/blog/:slug()",
    meta: _91slug_93cXioxiEr7bMeta || {},
    alias: _91slug_93cXioxiEr7bMeta?.alias || [],
    redirect: _91slug_93cXioxiEr7bMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93BF43XaeoiDMeta?.name ?? "blog-authors-slug___en",
    path: _91slug_93BF43XaeoiDMeta?.path ?? "/en/blog/authors/:slug()",
    meta: _91slug_93BF43XaeoiDMeta || {},
    alias: _91slug_93BF43XaeoiDMeta?.alias || [],
    redirect: _91slug_93BF43XaeoiDMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/authors/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93BF43XaeoiDMeta?.name ?? "blog-authors-slug___es",
    path: _91slug_93BF43XaeoiDMeta?.path ?? "/es/blog/authors/:slug()",
    meta: _91slug_93BF43XaeoiDMeta || {},
    alias: _91slug_93BF43XaeoiDMeta?.alias || [],
    redirect: _91slug_93BF43XaeoiDMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/authors/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexjKH6jSfTSdMeta?.name ?? "blog-authors___en",
    path: indexjKH6jSfTSdMeta?.path ?? "/en/blog/authors",
    meta: indexjKH6jSfTSdMeta || {},
    alias: indexjKH6jSfTSdMeta?.alias || [],
    redirect: indexjKH6jSfTSdMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/authors/index.vue").then(m => m.default || m)
  },
  {
    name: indexjKH6jSfTSdMeta?.name ?? "blog-authors___es",
    path: indexjKH6jSfTSdMeta?.path ?? "/es/blog/authors",
    meta: indexjKH6jSfTSdMeta || {},
    alias: indexjKH6jSfTSdMeta?.alias || [],
    redirect: indexjKH6jSfTSdMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/authors/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93cEB1nN3s1oMeta?.name ?? "blog-categories-slug___en",
    path: _91slug_93cEB1nN3s1oMeta?.path ?? "/en/blog/categories/:slug()",
    meta: _91slug_93cEB1nN3s1oMeta || {},
    alias: _91slug_93cEB1nN3s1oMeta?.alias || [],
    redirect: _91slug_93cEB1nN3s1oMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/categories/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93cEB1nN3s1oMeta?.name ?? "blog-categories-slug___es",
    path: _91slug_93cEB1nN3s1oMeta?.path ?? "/es/blog/categories/:slug()",
    meta: _91slug_93cEB1nN3s1oMeta || {},
    alias: _91slug_93cEB1nN3s1oMeta?.alias || [],
    redirect: _91slug_93cEB1nN3s1oMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/categories/[slug].vue").then(m => m.default || m)
  },
  {
    name: index3JdQccMEcZMeta?.name ?? "blog___en",
    path: index3JdQccMEcZMeta?.path ?? "/en/blog",
    meta: index3JdQccMEcZMeta || {},
    alias: index3JdQccMEcZMeta?.alias || [],
    redirect: index3JdQccMEcZMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index3JdQccMEcZMeta?.name ?? "blog___es",
    path: index3JdQccMEcZMeta?.path ?? "/es/blog",
    meta: index3JdQccMEcZMeta || {},
    alias: index3JdQccMEcZMeta?.alias || [],
    redirect: index3JdQccMEcZMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93W2c0teDQWlMeta?.name ?? "blog-tags-slug___en",
    path: _91slug_93W2c0teDQWlMeta?.path ?? "/en/blog/tags/:slug()",
    meta: _91slug_93W2c0teDQWlMeta || {},
    alias: _91slug_93W2c0teDQWlMeta?.alias || [],
    redirect: _91slug_93W2c0teDQWlMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/tags/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93W2c0teDQWlMeta?.name ?? "blog-tags-slug___es",
    path: _91slug_93W2c0teDQWlMeta?.path ?? "/es/blog/tags/:slug()",
    meta: _91slug_93W2c0teDQWlMeta || {},
    alias: _91slug_93W2c0teDQWlMeta?.alias || [],
    redirect: _91slug_93W2c0teDQWlMeta?.redirect || undefined,
    component: () => import("/data/pages/blog/tags/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en",
    path: indexVag119Ai9QMeta?.path ?? "/en/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-ca",
    path: indexVag119Ai9QMeta?.path ?? "/en-ca/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-co",
    path: indexVag119Ai9QMeta?.path ?? "/en-co/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___es-co",
    path: indexVag119Ai9QMeta?.path ?? "/es-co/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-cr",
    path: indexVag119Ai9QMeta?.path ?? "/en-cr/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___es-cr",
    path: indexVag119Ai9QMeta?.path ?? "/es-cr/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-es",
    path: indexVag119Ai9QMeta?.path ?? "/en-es/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___es",
    path: indexVag119Ai9QMeta?.path ?? "/es/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___es-es",
    path: indexVag119Ai9QMeta?.path ?? "/es-es/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-ge",
    path: indexVag119Ai9QMeta?.path ?? "/en-ge/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-gb",
    path: indexVag119Ai9QMeta?.path ?? "/en-gb/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-us",
    path: indexVag119Ai9QMeta?.path ?? "/en-us/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-hk",
    path: indexVag119Ai9QMeta?.path ?? "/en-hk/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-hu",
    path: indexVag119Ai9QMeta?.path ?? "/en-hu/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___hu-hu",
    path: indexVag119Ai9QMeta?.path ?? "/hu-hu/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-in",
    path: indexVag119Ai9QMeta?.path ?? "/en-in/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-ie",
    path: indexVag119Ai9QMeta?.path ?? "/en-ie/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-au",
    path: indexVag119Ai9QMeta?.path ?? "/en-au/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-pa",
    path: indexVag119Ai9QMeta?.path ?? "/en-pa/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___es-pa",
    path: indexVag119Ai9QMeta?.path ?? "/es-pa/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-pe",
    path: indexVag119Ai9QMeta?.path ?? "/en-pe/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___es-pe",
    path: indexVag119Ai9QMeta?.path ?? "/es-pe/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-pl",
    path: indexVag119Ai9QMeta?.path ?? "/en-pl/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___pl-pl",
    path: indexVag119Ai9QMeta?.path ?? "/pl-pl/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-pt",
    path: indexVag119Ai9QMeta?.path ?? "/en-pt/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___pt-pt",
    path: indexVag119Ai9QMeta?.path ?? "/pt-pt/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-ro",
    path: indexVag119Ai9QMeta?.path ?? "/en-ro/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-za",
    path: indexVag119Ai9QMeta?.path ?? "/en-za/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-ae",
    path: indexVag119Ai9QMeta?.path ?? "/en-ae/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-sa",
    path: indexVag119Ai9QMeta?.path ?? "/en-sa/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-om",
    path: indexVag119Ai9QMeta?.path ?? "/en-om/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-kw",
    path: indexVag119Ai9QMeta?.path ?? "/en-kw/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-bh",
    path: indexVag119Ai9QMeta?.path ?? "/en-bh/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-qa",
    path: indexVag119Ai9QMeta?.path ?? "/en-qa/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-ke",
    path: indexVag119Ai9QMeta?.path ?? "/en-ke/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexVag119Ai9QMeta?.name ?? "checkout___en-ng",
    path: indexVag119Ai9QMeta?.path ?? "/en-ng/checkout",
    meta: indexVag119Ai9QMeta || {},
    alias: indexVag119Ai9QMeta?.alias || [],
    redirect: indexVag119Ai9QMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-ca",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-ca/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-co",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-co/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___es-co",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/es-co/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-cr",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-cr/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___es-cr",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/es-cr/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-es",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-es/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___es",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/es/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___es-es",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/es-es/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-ge",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-ge/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-gb",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-gb/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-us",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-us/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-hk",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-hk/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-hu",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-hu/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___hu-hu",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/hu-hu/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-in",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-in/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-ie",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-ie/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-au",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-au/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-pa",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-pa/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___es-pa",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/es-pa/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-pe",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-pe/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___es-pe",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/es-pe/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-pl",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-pl/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___pl-pl",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/pl-pl/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-pt",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-pt/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___pt-pt",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/pt-pt/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-ro",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-ro/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-za",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-za/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-ae",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-ae/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-sa",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-sa/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-om",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-om/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-kw",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-kw/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-bh",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-bh/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-qa",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-qa/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-ke",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-ke/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youjeL9gqfYoWMeta?.name ?? "checkout-thank-you___en-ng",
    path: thank_45youjeL9gqfYoWMeta?.path ?? "/en-ng/checkout/thank-you",
    meta: thank_45youjeL9gqfYoWMeta || {},
    alias: thank_45youjeL9gqfYoWMeta?.alias || [],
    redirect: thank_45youjeL9gqfYoWMeta?.redirect || undefined,
    component: () => import("/data/pages/checkout/thank-you.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-ca",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-ca/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-co",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-co/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___es-co",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/es-co/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-cr",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-cr/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___es-cr",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/es-cr/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-es",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-es/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___es",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/es/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___es-es",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/es-es/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-ge",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-ge/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-gb",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-gb/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-us",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-us/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-hk",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-hk/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-hu",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-hu/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___hu-hu",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/hu-hu/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-in",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-in/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-ie",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-ie/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-au",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-au/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-pa",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-pa/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___es-pa",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/es-pa/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-pe",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-pe/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___es-pe",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/es-pe/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-pl",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-pl/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___pl-pl",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/pl-pl/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-pt",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-pt/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___pt-pt",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/pt-pt/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-ro",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-ro/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-za",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-za/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-ae",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-ae/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-sa",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-sa/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-om",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-om/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-kw",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-kw/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-bh",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-bh/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-qa",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-qa/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-ke",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-ke/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93eL5cIth4EPMeta?.name ?? "clinics-slug___en-ng",
    path: _91slug_93eL5cIth4EPMeta?.path ?? "/en-ng/clinics/:slug()",
    meta: _91slug_93eL5cIth4EPMeta || {},
    alias: _91slug_93eL5cIth4EPMeta?.alias || [],
    redirect: _91slug_93eL5cIth4EPMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/[slug].vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-ca",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-ca/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-co",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-co/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___es-co",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/es-co/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-cr",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-cr/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___es-cr",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/es-cr/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-es",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-es/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___es",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/es/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___es-es",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/es-es/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-ge",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-ge/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-gb",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-gb/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-us",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-us/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-hk",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-hk/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-hu",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-hu/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___hu-hu",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/hu-hu/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-in",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-in/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-ie",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-ie/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-au",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-au/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-pa",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-pa/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___es-pa",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/es-pa/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-pe",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-pe/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___es-pe",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/es-pe/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-pl",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-pl/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___pl-pl",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/pl-pl/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-pt",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-pt/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___pt-pt",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/pt-pt/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-ro",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-ro/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-za",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-za/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-ae",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-ae/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-sa",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-sa/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-om",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-om/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-kw",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-kw/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-bh",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-bh/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-qa",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-qa/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-ke",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-ke/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: city_45listing9c2P70j0p9Meta?.name ?? "clinics-components-city-listing___en-ng",
    path: city_45listing9c2P70j0p9Meta?.path ?? "/en-ng/clinics/components/city-listing",
    meta: city_45listing9c2P70j0p9Meta || {},
    alias: city_45listing9c2P70j0p9Meta?.alias || [],
    redirect: city_45listing9c2P70j0p9Meta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/city-listing.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-ca",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-ca/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-co",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-co/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___es-co",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/es-co/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-cr",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-cr/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___es-cr",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/es-cr/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-es",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-es/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___es",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/es/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___es-es",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/es-es/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-ge",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-ge/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-gb",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-gb/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-us",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-us/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-hk",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-hk/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-hu",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-hu/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___hu-hu",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/hu-hu/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-in",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-in/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-ie",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-ie/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-au",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-au/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-pa",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-pa/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___es-pa",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/es-pa/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-pe",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-pe/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___es-pe",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/es-pe/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-pl",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-pl/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___pl-pl",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/pl-pl/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-pt",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-pt/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___pt-pt",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/pt-pt/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-ro",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-ro/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-za",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-za/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-ae",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-ae/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-sa",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-sa/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-om",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-om/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-kw",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-kw/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-bh",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-bh/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-qa",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-qa/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-ke",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-ke/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: detail_45viewFmlqOz8UAaMeta?.name ?? "clinics-components-detail-view___en-ng",
    path: detail_45viewFmlqOz8UAaMeta?.path ?? "/en-ng/clinics/components/detail-view",
    meta: detail_45viewFmlqOz8UAaMeta || {},
    alias: detail_45viewFmlqOz8UAaMeta?.alias || [],
    redirect: detail_45viewFmlqOz8UAaMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/components/detail-view.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en",
    path: index5eSz7sUw3TMeta?.path ?? "/en/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-ca",
    path: index5eSz7sUw3TMeta?.path ?? "/en-ca/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-co",
    path: index5eSz7sUw3TMeta?.path ?? "/en-co/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___es-co",
    path: index5eSz7sUw3TMeta?.path ?? "/es-co/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-cr",
    path: index5eSz7sUw3TMeta?.path ?? "/en-cr/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___es-cr",
    path: index5eSz7sUw3TMeta?.path ?? "/es-cr/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-es",
    path: index5eSz7sUw3TMeta?.path ?? "/en-es/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___es",
    path: index5eSz7sUw3TMeta?.path ?? "/es/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___es-es",
    path: index5eSz7sUw3TMeta?.path ?? "/es-es/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-ge",
    path: index5eSz7sUw3TMeta?.path ?? "/en-ge/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-gb",
    path: index5eSz7sUw3TMeta?.path ?? "/en-gb/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-us",
    path: index5eSz7sUw3TMeta?.path ?? "/en-us/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-hk",
    path: index5eSz7sUw3TMeta?.path ?? "/en-hk/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-hu",
    path: index5eSz7sUw3TMeta?.path ?? "/en-hu/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___hu-hu",
    path: index5eSz7sUw3TMeta?.path ?? "/hu-hu/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-in",
    path: index5eSz7sUw3TMeta?.path ?? "/en-in/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-ie",
    path: index5eSz7sUw3TMeta?.path ?? "/en-ie/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-au",
    path: index5eSz7sUw3TMeta?.path ?? "/en-au/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-pa",
    path: index5eSz7sUw3TMeta?.path ?? "/en-pa/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___es-pa",
    path: index5eSz7sUw3TMeta?.path ?? "/es-pa/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-pe",
    path: index5eSz7sUw3TMeta?.path ?? "/en-pe/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___es-pe",
    path: index5eSz7sUw3TMeta?.path ?? "/es-pe/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-pl",
    path: index5eSz7sUw3TMeta?.path ?? "/en-pl/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___pl-pl",
    path: index5eSz7sUw3TMeta?.path ?? "/pl-pl/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-pt",
    path: index5eSz7sUw3TMeta?.path ?? "/en-pt/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___pt-pt",
    path: index5eSz7sUw3TMeta?.path ?? "/pt-pt/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-ro",
    path: index5eSz7sUw3TMeta?.path ?? "/en-ro/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-za",
    path: index5eSz7sUw3TMeta?.path ?? "/en-za/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-ae",
    path: index5eSz7sUw3TMeta?.path ?? "/en-ae/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-sa",
    path: index5eSz7sUw3TMeta?.path ?? "/en-sa/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-om",
    path: index5eSz7sUw3TMeta?.path ?? "/en-om/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-kw",
    path: index5eSz7sUw3TMeta?.path ?? "/en-kw/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-bh",
    path: index5eSz7sUw3TMeta?.path ?? "/en-bh/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-qa",
    path: index5eSz7sUw3TMeta?.path ?? "/en-qa/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-ke",
    path: index5eSz7sUw3TMeta?.path ?? "/en-ke/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: index5eSz7sUw3TMeta?.name ?? "clinics___en-ng",
    path: index5eSz7sUw3TMeta?.path ?? "/en-ng/clinics",
    meta: index5eSz7sUw3TMeta || {},
    alias: index5eSz7sUw3TMeta?.alias || [],
    redirect: index5eSz7sUw3TMeta?.redirect || undefined,
    component: () => import("/data/pages/clinics/index.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-ca",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-ca/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-co",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-co/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___es-co",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/es-co/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-cr",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-cr/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___es-cr",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/es-cr/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-es",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-es/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___es",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/es/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___es-es",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/es-es/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-ge",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-ge/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-gb",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-gb/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-us",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-us/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-hk",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-hk/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-hu",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-hu/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___hu-hu",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/hu-hu/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-in",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-in/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-ie",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-ie/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-au",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-au/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-pa",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-pa/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___es-pa",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/es-pa/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-pe",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-pe/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___es-pe",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/es-pe/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-pl",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-pl/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___pl-pl",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/pl-pl/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-pt",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-pt/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___pt-pt",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/pt-pt/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-ro",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-ro/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-za",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-za/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-ae",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-ae/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-sa",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-sa/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-om",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-om/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-kw",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-kw/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-bh",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-bh/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-qa",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-qa/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-ke",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-ke/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45usVb7LZb4YQxMeta?.name ?? "contact-us___en-ng",
    path: contact_45usVb7LZb4YQxMeta?.path ?? "/en-ng/contact-us",
    meta: contact_45usVb7LZb4YQxMeta || {},
    alias: contact_45usVb7LZb4YQxMeta?.alias || [],
    redirect: contact_45usVb7LZb4YQxMeta?.redirect || undefined,
    component: () => import("/data/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en",
    path: indexojFm3fXhJiMeta?.path ?? "/en/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-ca",
    path: indexojFm3fXhJiMeta?.path ?? "/en-ca/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-co",
    path: indexojFm3fXhJiMeta?.path ?? "/en-co/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___es-co",
    path: indexojFm3fXhJiMeta?.path ?? "/es-co/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-cr",
    path: indexojFm3fXhJiMeta?.path ?? "/en-cr/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___es-cr",
    path: indexojFm3fXhJiMeta?.path ?? "/es-cr/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-es",
    path: indexojFm3fXhJiMeta?.path ?? "/en-es/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___es",
    path: indexojFm3fXhJiMeta?.path ?? "/es/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___es-es",
    path: indexojFm3fXhJiMeta?.path ?? "/es-es/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-ge",
    path: indexojFm3fXhJiMeta?.path ?? "/en-ge/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-gb",
    path: indexojFm3fXhJiMeta?.path ?? "/en-gb/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-us",
    path: indexojFm3fXhJiMeta?.path ?? "/en-us/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-hk",
    path: indexojFm3fXhJiMeta?.path ?? "/en-hk/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-hu",
    path: indexojFm3fXhJiMeta?.path ?? "/en-hu/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___hu-hu",
    path: indexojFm3fXhJiMeta?.path ?? "/hu-hu/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-in",
    path: indexojFm3fXhJiMeta?.path ?? "/en-in/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-ie",
    path: indexojFm3fXhJiMeta?.path ?? "/en-ie/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-au",
    path: indexojFm3fXhJiMeta?.path ?? "/en-au/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-pa",
    path: indexojFm3fXhJiMeta?.path ?? "/en-pa/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___es-pa",
    path: indexojFm3fXhJiMeta?.path ?? "/es-pa/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-pe",
    path: indexojFm3fXhJiMeta?.path ?? "/en-pe/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___es-pe",
    path: indexojFm3fXhJiMeta?.path ?? "/es-pe/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-pl",
    path: indexojFm3fXhJiMeta?.path ?? "/en-pl/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___pl-pl",
    path: indexojFm3fXhJiMeta?.path ?? "/pl-pl/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-pt",
    path: indexojFm3fXhJiMeta?.path ?? "/en-pt/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___pt-pt",
    path: indexojFm3fXhJiMeta?.path ?? "/pt-pt/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-ro",
    path: indexojFm3fXhJiMeta?.path ?? "/en-ro/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-za",
    path: indexojFm3fXhJiMeta?.path ?? "/en-za/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-ae",
    path: indexojFm3fXhJiMeta?.path ?? "/en-ae/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-sa",
    path: indexojFm3fXhJiMeta?.path ?? "/en-sa/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-om",
    path: indexojFm3fXhJiMeta?.path ?? "/en-om/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-kw",
    path: indexojFm3fXhJiMeta?.path ?? "/en-kw/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-bh",
    path: indexojFm3fXhJiMeta?.path ?? "/en-bh/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-qa",
    path: indexojFm3fXhJiMeta?.path ?? "/en-qa/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-ke",
    path: indexojFm3fXhJiMeta?.path ?? "/en-ke/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexojFm3fXhJiMeta?.name ?? "direct-payment-order_token___en-ng",
    path: indexojFm3fXhJiMeta?.path ?? "/en-ng/direct-payment/:order_token()",
    meta: indexojFm3fXhJiMeta || {},
    alias: indexojFm3fXhJiMeta?.alias || [],
    redirect: indexojFm3fXhJiMeta?.redirect || undefined,
    component: () => import("/data/pages/direct-payment/[order_token]/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-ca",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-ca/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-co",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-co/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___es-co",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/es-co/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-cr",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-cr/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___es-cr",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/es-cr/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-es",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-es/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___es",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/es/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___es-es",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/es-es/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-ge",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-ge/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-gb",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-gb/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-us",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-us/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-hk",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-hk/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-hu",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-hu/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___hu-hu",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/hu-hu/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-in",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-in/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-ie",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-ie/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-au",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-au/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-pa",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-pa/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___es-pa",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/es-pa/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-pe",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-pe/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___es-pe",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/es-pe/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-pl",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-pl/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___pl-pl",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/pl-pl/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-pt",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-pt/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___pt-pt",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/pt-pt/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-ro",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-ro/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-za",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-za/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-ae",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-ae/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-sa",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-sa/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-om",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-om/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-kw",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-kw/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-bh",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-bh/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-qa",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-qa/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-ke",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-ke/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wLojpWP9YDMeta?.name ?? "faqs-slug___en-ng",
    path: _91slug_93wLojpWP9YDMeta?.path ?? "/en-ng/faqs/:slug()",
    meta: _91slug_93wLojpWP9YDMeta || {},
    alias: _91slug_93wLojpWP9YDMeta?.alias || [],
    redirect: _91slug_93wLojpWP9YDMeta?.redirect || undefined,
    component: () => import("/data/pages/faqs/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en",
    path: indexLfZweG7Ef2Meta?.path ?? "/en/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-ca",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-ca/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-co",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-co/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___es-co",
    path: indexLfZweG7Ef2Meta?.path ?? "/es-co/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-cr",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-cr/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___es-cr",
    path: indexLfZweG7Ef2Meta?.path ?? "/es-cr/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-es",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-es/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___es",
    path: indexLfZweG7Ef2Meta?.path ?? "/es/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___es-es",
    path: indexLfZweG7Ef2Meta?.path ?? "/es-es/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-ge",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-ge/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-gb",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-gb/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-us",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-us/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-hk",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-hk/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-hu",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-hu/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___hu-hu",
    path: indexLfZweG7Ef2Meta?.path ?? "/hu-hu/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-in",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-in/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-ie",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-ie/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-au",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-au/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-pa",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-pa/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___es-pa",
    path: indexLfZweG7Ef2Meta?.path ?? "/es-pa/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-pe",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-pe/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___es-pe",
    path: indexLfZweG7Ef2Meta?.path ?? "/es-pe/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-pl",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-pl/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___pl-pl",
    path: indexLfZweG7Ef2Meta?.path ?? "/pl-pl/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-pt",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-pt/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___pt-pt",
    path: indexLfZweG7Ef2Meta?.path ?? "/pt-pt/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-ro",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-ro/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-za",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-za/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-ae",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-ae/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-sa",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-sa/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-om",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-om/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-kw",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-kw/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-bh",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-bh/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-qa",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-qa/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-ke",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-ke/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: indexLfZweG7Ef2Meta?.name ?? "faqs___en-ng",
    path: indexLfZweG7Ef2Meta?.path ?? "/en-ng/faqs",
    meta: indexLfZweG7Ef2Meta || {},
    alias: indexLfZweG7Ef2Meta?.alias || [],
    redirect: indexLfZweG7Ef2Meta?.redirect || undefined,
    component: () => import("/data/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en",
    path: index0sTCdVluXDMeta?.path ?? "/en/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-ca",
    path: index0sTCdVluXDMeta?.path ?? "/en-ca/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-co",
    path: index0sTCdVluXDMeta?.path ?? "/en-co/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___es-co",
    path: index0sTCdVluXDMeta?.path ?? "/es-co/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-cr",
    path: index0sTCdVluXDMeta?.path ?? "/en-cr/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___es-cr",
    path: index0sTCdVluXDMeta?.path ?? "/es-cr/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-es",
    path: index0sTCdVluXDMeta?.path ?? "/en-es/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___es",
    path: index0sTCdVluXDMeta?.path ?? "/es/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___es-es",
    path: index0sTCdVluXDMeta?.path ?? "/es-es/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-ge",
    path: index0sTCdVluXDMeta?.path ?? "/en-ge/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-gb",
    path: index0sTCdVluXDMeta?.path ?? "/en-gb/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-us",
    path: index0sTCdVluXDMeta?.path ?? "/en-us/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-hk",
    path: index0sTCdVluXDMeta?.path ?? "/en-hk/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-hu",
    path: index0sTCdVluXDMeta?.path ?? "/en-hu/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___hu-hu",
    path: index0sTCdVluXDMeta?.path ?? "/hu-hu/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-in",
    path: index0sTCdVluXDMeta?.path ?? "/en-in/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-ie",
    path: index0sTCdVluXDMeta?.path ?? "/en-ie/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-au",
    path: index0sTCdVluXDMeta?.path ?? "/en-au/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-pa",
    path: index0sTCdVluXDMeta?.path ?? "/en-pa/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___es-pa",
    path: index0sTCdVluXDMeta?.path ?? "/es-pa/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-pe",
    path: index0sTCdVluXDMeta?.path ?? "/en-pe/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___es-pe",
    path: index0sTCdVluXDMeta?.path ?? "/es-pe/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-pl",
    path: index0sTCdVluXDMeta?.path ?? "/en-pl/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___pl-pl",
    path: index0sTCdVluXDMeta?.path ?? "/pl-pl/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-pt",
    path: index0sTCdVluXDMeta?.path ?? "/en-pt/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___pt-pt",
    path: index0sTCdVluXDMeta?.path ?? "/pt-pt/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-ro",
    path: index0sTCdVluXDMeta?.path ?? "/en-ro/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-za",
    path: index0sTCdVluXDMeta?.path ?? "/en-za/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-ae",
    path: index0sTCdVluXDMeta?.path ?? "/en-ae/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-sa",
    path: index0sTCdVluXDMeta?.path ?? "/en-sa/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-om",
    path: index0sTCdVluXDMeta?.path ?? "/en-om/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-kw",
    path: index0sTCdVluXDMeta?.path ?? "/en-kw/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-bh",
    path: index0sTCdVluXDMeta?.path ?? "/en-bh/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-qa",
    path: index0sTCdVluXDMeta?.path ?? "/en-qa/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-ke",
    path: index0sTCdVluXDMeta?.path ?? "/en-ke/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: index0sTCdVluXDMeta?.name ?? "get-started-section-service-category___en-ng",
    path: index0sTCdVluXDMeta?.path ?? "/en-ng/get-started/:section?/:service?/:category?",
    meta: index0sTCdVluXDMeta || {},
    alias: index0sTCdVluXDMeta?.alias || [],
    redirect: index0sTCdVluXDMeta?.redirect || undefined,
    component: () => import("/data/pages/get-started/[[section]]/[[service]]/[[category]]/index.vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-ca",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-ca/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-co",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-co/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___es-co",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/es-co/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-cr",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-cr/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___es-cr",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/es-cr/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-es",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-es/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___es",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/es/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___es-es",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/es-es/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-ge",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-ge/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-gb",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-gb/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-us",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-us/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-hk",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-hk/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-hu",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-hu/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___hu-hu",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/hu-hu/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-in",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-in/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-ie",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-ie/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-au",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-au/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-pa",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-pa/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___es-pa",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/es-pa/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-pe",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-pe/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___es-pe",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/es-pe/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-pl",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-pl/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___pl-pl",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/pl-pl/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-pt",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-pt/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___pt-pt",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/pt-pt/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-ro",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-ro/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-za",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-za/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-ae",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-ae/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-sa",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-sa/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-om",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-om/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-kw",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-kw/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-bh",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-bh/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-qa",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-qa/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-ke",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-ke/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: _91condition_93IYA8PUM8TrMeta?.name ?? "help-and-advice-category-slug-condition___en-ng",
    path: _91condition_93IYA8PUM8TrMeta?.path ?? "/en-ng/help-and-advice/:category()/:slug()/:condition()",
    meta: _91condition_93IYA8PUM8TrMeta || {},
    alias: _91condition_93IYA8PUM8TrMeta?.alias || [],
    redirect: _91condition_93IYA8PUM8TrMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/[condition].vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en",
    path: indexZeiT6zQX5VMeta?.path ?? "/en/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-ca",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-ca/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-co",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-co/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___es-co",
    path: indexZeiT6zQX5VMeta?.path ?? "/es-co/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-cr",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-cr/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___es-cr",
    path: indexZeiT6zQX5VMeta?.path ?? "/es-cr/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-es",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-es/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___es",
    path: indexZeiT6zQX5VMeta?.path ?? "/es/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___es-es",
    path: indexZeiT6zQX5VMeta?.path ?? "/es-es/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-ge",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-ge/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-gb",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-gb/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-us",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-us/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-hk",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-hk/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-hu",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-hu/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___hu-hu",
    path: indexZeiT6zQX5VMeta?.path ?? "/hu-hu/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-in",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-in/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-ie",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-ie/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-au",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-au/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-pa",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-pa/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___es-pa",
    path: indexZeiT6zQX5VMeta?.path ?? "/es-pa/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-pe",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-pe/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___es-pe",
    path: indexZeiT6zQX5VMeta?.path ?? "/es-pe/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-pl",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-pl/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___pl-pl",
    path: indexZeiT6zQX5VMeta?.path ?? "/pl-pl/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-pt",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-pt/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___pt-pt",
    path: indexZeiT6zQX5VMeta?.path ?? "/pt-pt/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-ro",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-ro/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-za",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-za/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-ae",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-ae/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-sa",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-sa/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-om",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-om/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-kw",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-kw/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-bh",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-bh/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-qa",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-qa/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-ke",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-ke/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZeiT6zQX5VMeta?.name ?? "help-and-advice-category-slug___en-ng",
    path: indexZeiT6zQX5VMeta?.path ?? "/en-ng/help-and-advice/:category()/:slug()",
    meta: indexZeiT6zQX5VMeta || {},
    alias: indexZeiT6zQX5VMeta?.alias || [],
    redirect: indexZeiT6zQX5VMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en",
    path: index9wTWHSpoWsMeta?.path ?? "/en/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-ca",
    path: index9wTWHSpoWsMeta?.path ?? "/en-ca/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-co",
    path: index9wTWHSpoWsMeta?.path ?? "/en-co/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___es-co",
    path: index9wTWHSpoWsMeta?.path ?? "/es-co/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-cr",
    path: index9wTWHSpoWsMeta?.path ?? "/en-cr/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___es-cr",
    path: index9wTWHSpoWsMeta?.path ?? "/es-cr/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-es",
    path: index9wTWHSpoWsMeta?.path ?? "/en-es/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___es",
    path: index9wTWHSpoWsMeta?.path ?? "/es/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___es-es",
    path: index9wTWHSpoWsMeta?.path ?? "/es-es/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-ge",
    path: index9wTWHSpoWsMeta?.path ?? "/en-ge/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-gb",
    path: index9wTWHSpoWsMeta?.path ?? "/en-gb/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-us",
    path: index9wTWHSpoWsMeta?.path ?? "/en-us/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-hk",
    path: index9wTWHSpoWsMeta?.path ?? "/en-hk/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-hu",
    path: index9wTWHSpoWsMeta?.path ?? "/en-hu/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___hu-hu",
    path: index9wTWHSpoWsMeta?.path ?? "/hu-hu/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-in",
    path: index9wTWHSpoWsMeta?.path ?? "/en-in/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-ie",
    path: index9wTWHSpoWsMeta?.path ?? "/en-ie/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-au",
    path: index9wTWHSpoWsMeta?.path ?? "/en-au/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-pa",
    path: index9wTWHSpoWsMeta?.path ?? "/en-pa/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___es-pa",
    path: index9wTWHSpoWsMeta?.path ?? "/es-pa/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-pe",
    path: index9wTWHSpoWsMeta?.path ?? "/en-pe/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___es-pe",
    path: index9wTWHSpoWsMeta?.path ?? "/es-pe/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-pl",
    path: index9wTWHSpoWsMeta?.path ?? "/en-pl/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___pl-pl",
    path: index9wTWHSpoWsMeta?.path ?? "/pl-pl/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-pt",
    path: index9wTWHSpoWsMeta?.path ?? "/en-pt/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___pt-pt",
    path: index9wTWHSpoWsMeta?.path ?? "/pt-pt/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-ro",
    path: index9wTWHSpoWsMeta?.path ?? "/en-ro/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-za",
    path: index9wTWHSpoWsMeta?.path ?? "/en-za/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-ae",
    path: index9wTWHSpoWsMeta?.path ?? "/en-ae/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-sa",
    path: index9wTWHSpoWsMeta?.path ?? "/en-sa/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-om",
    path: index9wTWHSpoWsMeta?.path ?? "/en-om/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-kw",
    path: index9wTWHSpoWsMeta?.path ?? "/en-kw/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-bh",
    path: index9wTWHSpoWsMeta?.path ?? "/en-bh/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-qa",
    path: index9wTWHSpoWsMeta?.path ?? "/en-qa/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-ke",
    path: index9wTWHSpoWsMeta?.path ?? "/en-ke/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9wTWHSpoWsMeta?.name ?? "help-and-advice-category___en-ng",
    path: index9wTWHSpoWsMeta?.path ?? "/en-ng/help-and-advice/:category()",
    meta: index9wTWHSpoWsMeta || {},
    alias: index9wTWHSpoWsMeta?.alias || [],
    redirect: index9wTWHSpoWsMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en",
    path: indexjAaK7ryr1uMeta?.path ?? "/en/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-ca",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-ca/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-co",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-co/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___es-co",
    path: indexjAaK7ryr1uMeta?.path ?? "/es-co/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-cr",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-cr/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___es-cr",
    path: indexjAaK7ryr1uMeta?.path ?? "/es-cr/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-es",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-es/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___es",
    path: indexjAaK7ryr1uMeta?.path ?? "/es/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___es-es",
    path: indexjAaK7ryr1uMeta?.path ?? "/es-es/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-ge",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-ge/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-gb",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-gb/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-us",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-us/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-hk",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-hk/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-hu",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-hu/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___hu-hu",
    path: indexjAaK7ryr1uMeta?.path ?? "/hu-hu/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-in",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-in/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-ie",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-ie/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-au",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-au/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-pa",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-pa/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___es-pa",
    path: indexjAaK7ryr1uMeta?.path ?? "/es-pa/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-pe",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-pe/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___es-pe",
    path: indexjAaK7ryr1uMeta?.path ?? "/es-pe/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-pl",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-pl/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___pl-pl",
    path: indexjAaK7ryr1uMeta?.path ?? "/pl-pl/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-pt",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-pt/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___pt-pt",
    path: indexjAaK7ryr1uMeta?.path ?? "/pt-pt/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-ro",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-ro/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-za",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-za/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-ae",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-ae/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-sa",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-sa/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-om",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-om/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-kw",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-kw/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-bh",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-bh/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-qa",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-qa/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-ke",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-ke/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexjAaK7ryr1uMeta?.name ?? "help-and-advice___en-ng",
    path: indexjAaK7ryr1uMeta?.path ?? "/en-ng/help-and-advice",
    meta: indexjAaK7ryr1uMeta || {},
    alias: indexjAaK7ryr1uMeta?.alias || [],
    redirect: indexjAaK7ryr1uMeta?.redirect || undefined,
    component: () => import("/data/pages/help-and-advice/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en",
    path: indexwJM0pWSZGwMeta?.path ?? "/en",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-ca",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-ca",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-co",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-co",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___es-co",
    path: indexwJM0pWSZGwMeta?.path ?? "/es-co",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-cr",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-cr",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___es-cr",
    path: indexwJM0pWSZGwMeta?.path ?? "/es-cr",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-es",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-es",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___es",
    path: indexwJM0pWSZGwMeta?.path ?? "/es",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___es-es",
    path: indexwJM0pWSZGwMeta?.path ?? "/es-es",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-ge",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-ge",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-gb",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-gb",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-us",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-us",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-hk",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-hk",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-hu",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-hu",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___hu-hu",
    path: indexwJM0pWSZGwMeta?.path ?? "/hu-hu",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-in",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-in",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-ie",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-ie",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-au",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-au",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-pa",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-pa",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___es-pa",
    path: indexwJM0pWSZGwMeta?.path ?? "/es-pa",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-pe",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-pe",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___es-pe",
    path: indexwJM0pWSZGwMeta?.path ?? "/es-pe",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-pl",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-pl",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___pl-pl",
    path: indexwJM0pWSZGwMeta?.path ?? "/pl-pl",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-pt",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-pt",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___pt-pt",
    path: indexwJM0pWSZGwMeta?.path ?? "/pt-pt",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-ro",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-ro",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-za",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-za",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-ae",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-ae",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-sa",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-sa",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-om",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-om",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-kw",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-kw",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-bh",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-bh",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-qa",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-qa",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-ke",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-ke",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexwJM0pWSZGwMeta?.name ?? "index___en-ng",
    path: indexwJM0pWSZGwMeta?.path ?? "/en-ng",
    meta: indexwJM0pWSZGwMeta || {},
    alias: indexwJM0pWSZGwMeta?.alias || [],
    redirect: indexwJM0pWSZGwMeta?.redirect || undefined,
    component: () => import("/data/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-ca",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-ca/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-co",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-co/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___es-co",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/es-co/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-cr",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-cr/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___es-cr",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/es-cr/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-es",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-es/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___es",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/es/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___es-es",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/es-es/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-ge",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-ge/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-gb",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-gb/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-us",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-us/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-hk",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-hk/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-hu",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-hu/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___hu-hu",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/hu-hu/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-in",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-in/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-ie",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-ie/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-au",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-au/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-pa",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-pa/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___es-pa",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/es-pa/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-pe",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-pe/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___es-pe",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/es-pe/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-pl",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-pl/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___pl-pl",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/pl-pl/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-pt",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-pt/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___pt-pt",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/pt-pt/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-ro",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-ro/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-za",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-za/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-ae",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-ae/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-sa",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-sa/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-om",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-om/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-kw",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-kw/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-bh",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-bh/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-qa",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-qa/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-ke",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-ke/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VAORsljsIBMeta?.name ?? "legal-and-privacy-slug___en-ng",
    path: _91slug_93VAORsljsIBMeta?.path ?? "/en-ng/legal-and-privacy/:slug()",
    meta: _91slug_93VAORsljsIBMeta || {},
    alias: _91slug_93VAORsljsIBMeta?.alias || [],
    redirect: _91slug_93VAORsljsIBMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en",
    path: indexSWPrnbyjTJMeta?.path ?? "/en/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-ca",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-ca/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-co",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-co/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___es-co",
    path: indexSWPrnbyjTJMeta?.path ?? "/es-co/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-cr",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-cr/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___es-cr",
    path: indexSWPrnbyjTJMeta?.path ?? "/es-cr/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-es",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-es/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___es",
    path: indexSWPrnbyjTJMeta?.path ?? "/es/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___es-es",
    path: indexSWPrnbyjTJMeta?.path ?? "/es-es/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-ge",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-ge/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-gb",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-gb/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-us",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-us/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-hk",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-hk/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-hu",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-hu/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___hu-hu",
    path: indexSWPrnbyjTJMeta?.path ?? "/hu-hu/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-in",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-in/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-ie",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-ie/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-au",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-au/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-pa",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-pa/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___es-pa",
    path: indexSWPrnbyjTJMeta?.path ?? "/es-pa/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-pe",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-pe/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___es-pe",
    path: indexSWPrnbyjTJMeta?.path ?? "/es-pe/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-pl",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-pl/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___pl-pl",
    path: indexSWPrnbyjTJMeta?.path ?? "/pl-pl/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-pt",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-pt/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___pt-pt",
    path: indexSWPrnbyjTJMeta?.path ?? "/pt-pt/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-ro",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-ro/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-za",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-za/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-ae",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-ae/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-sa",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-sa/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-om",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-om/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-kw",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-kw/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-bh",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-bh/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-qa",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-qa/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-ke",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-ke/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexSWPrnbyjTJMeta?.name ?? "legal-and-privacy___en-ng",
    path: indexSWPrnbyjTJMeta?.path ?? "/en-ng/legal-and-privacy",
    meta: indexSWPrnbyjTJMeta || {},
    alias: indexSWPrnbyjTJMeta?.alias || [],
    redirect: indexSWPrnbyjTJMeta?.redirect || undefined,
    component: () => import("/data/pages/legal-and-privacy/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en",
    path: indexJDLZt6uUb1Meta?.path ?? "/en/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-ca",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-ca/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-co",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-co/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___es-co",
    path: indexJDLZt6uUb1Meta?.path ?? "/es-co/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-cr",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-cr/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___es-cr",
    path: indexJDLZt6uUb1Meta?.path ?? "/es-cr/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-es",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-es/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___es",
    path: indexJDLZt6uUb1Meta?.path ?? "/es/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___es-es",
    path: indexJDLZt6uUb1Meta?.path ?? "/es-es/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-ge",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-ge/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-gb",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-gb/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-us",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-us/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-hk",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-hk/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-hu",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-hu/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___hu-hu",
    path: indexJDLZt6uUb1Meta?.path ?? "/hu-hu/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-in",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-in/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-ie",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-ie/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-au",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-au/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-pa",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-pa/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___es-pa",
    path: indexJDLZt6uUb1Meta?.path ?? "/es-pa/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-pe",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-pe/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___es-pe",
    path: indexJDLZt6uUb1Meta?.path ?? "/es-pe/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-pl",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-pl/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___pl-pl",
    path: indexJDLZt6uUb1Meta?.path ?? "/pl-pl/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-pt",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-pt/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___pt-pt",
    path: indexJDLZt6uUb1Meta?.path ?? "/pt-pt/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-ro",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-ro/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-za",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-za/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-ae",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-ae/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-sa",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-sa/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-om",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-om/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-kw",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-kw/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-bh",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-bh/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-qa",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-qa/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-ke",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-ke/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJDLZt6uUb1Meta?.name ?? "manual-payment-token___en-ng",
    path: indexJDLZt6uUb1Meta?.path ?? "/en-ng/manual-payment/:token()",
    meta: indexJDLZt6uUb1Meta || {},
    alias: indexJDLZt6uUb1Meta?.alias || [],
    redirect: indexJDLZt6uUb1Meta?.redirect || undefined,
    component: () => import("/data/pages/manual-payment/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en",
    path: indexS1tlGZUMklMeta?.path ?? "/en/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-ca",
    path: indexS1tlGZUMklMeta?.path ?? "/en-ca/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-co",
    path: indexS1tlGZUMklMeta?.path ?? "/en-co/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___es-co",
    path: indexS1tlGZUMklMeta?.path ?? "/es-co/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-cr",
    path: indexS1tlGZUMklMeta?.path ?? "/en-cr/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___es-cr",
    path: indexS1tlGZUMklMeta?.path ?? "/es-cr/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-es",
    path: indexS1tlGZUMklMeta?.path ?? "/en-es/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___es",
    path: indexS1tlGZUMklMeta?.path ?? "/es/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___es-es",
    path: indexS1tlGZUMklMeta?.path ?? "/es-es/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-ge",
    path: indexS1tlGZUMklMeta?.path ?? "/en-ge/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-gb",
    path: indexS1tlGZUMklMeta?.path ?? "/en-gb/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-us",
    path: indexS1tlGZUMklMeta?.path ?? "/en-us/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-hk",
    path: indexS1tlGZUMklMeta?.path ?? "/en-hk/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-hu",
    path: indexS1tlGZUMklMeta?.path ?? "/en-hu/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___hu-hu",
    path: indexS1tlGZUMklMeta?.path ?? "/hu-hu/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-in",
    path: indexS1tlGZUMklMeta?.path ?? "/en-in/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-ie",
    path: indexS1tlGZUMklMeta?.path ?? "/en-ie/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-au",
    path: indexS1tlGZUMklMeta?.path ?? "/en-au/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-pa",
    path: indexS1tlGZUMklMeta?.path ?? "/en-pa/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___es-pa",
    path: indexS1tlGZUMklMeta?.path ?? "/es-pa/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-pe",
    path: indexS1tlGZUMklMeta?.path ?? "/en-pe/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___es-pe",
    path: indexS1tlGZUMklMeta?.path ?? "/es-pe/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-pl",
    path: indexS1tlGZUMklMeta?.path ?? "/en-pl/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___pl-pl",
    path: indexS1tlGZUMklMeta?.path ?? "/pl-pl/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-pt",
    path: indexS1tlGZUMklMeta?.path ?? "/en-pt/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___pt-pt",
    path: indexS1tlGZUMklMeta?.path ?? "/pt-pt/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-ro",
    path: indexS1tlGZUMklMeta?.path ?? "/en-ro/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-za",
    path: indexS1tlGZUMklMeta?.path ?? "/en-za/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-ae",
    path: indexS1tlGZUMklMeta?.path ?? "/en-ae/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-sa",
    path: indexS1tlGZUMklMeta?.path ?? "/en-sa/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-om",
    path: indexS1tlGZUMklMeta?.path ?? "/en-om/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-kw",
    path: indexS1tlGZUMklMeta?.path ?? "/en-kw/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-bh",
    path: indexS1tlGZUMklMeta?.path ?? "/en-bh/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-qa",
    path: indexS1tlGZUMklMeta?.path ?? "/en-qa/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-ke",
    path: indexS1tlGZUMklMeta?.path ?? "/en-ke/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1tlGZUMklMeta?.name ?? "order-processing___en-ng",
    path: indexS1tlGZUMklMeta?.path ?? "/en-ng/order-processing",
    meta: indexS1tlGZUMklMeta || {},
    alias: indexS1tlGZUMklMeta?.alias || [],
    redirect: indexS1tlGZUMklMeta?.redirect || undefined,
    component: () => import("/data/pages/order-processing/index.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-ca",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-ca/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-co",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-co/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___es-co",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/es-co/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-cr",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-cr/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___es-cr",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/es-cr/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-es",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-es/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___es",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/es/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___es-es",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/es-es/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-ge",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-ge/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-gb",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-gb/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-us",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-us/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-hk",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-hk/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-hu",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-hu/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___hu-hu",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/hu-hu/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-in",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-in/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-ie",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-ie/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-au",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-au/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-pa",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-pa/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___es-pa",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/es-pa/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-pe",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-pe/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___es-pe",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/es-pe/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-pl",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-pl/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___pl-pl",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/pl-pl/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-pt",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-pt/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___pt-pt",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/pt-pt/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-ro",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-ro/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-za",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-za/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-ae",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-ae/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-sa",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-sa/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-om",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-om/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-kw",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-kw/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-bh",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-bh/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-qa",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-qa/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-ke",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-ke/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: policy_45detailtnulJGjISmMeta?.name ?? "policy-detail___en-ng",
    path: policy_45detailtnulJGjISmMeta?.path ?? "/en-ng/policy-detail",
    meta: policy_45detailtnulJGjISmMeta || {},
    alias: policy_45detailtnulJGjISmMeta?.alias || [],
    redirect: policy_45detailtnulJGjISmMeta?.redirect || undefined,
    component: () => import("/data/pages/policy-detail.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en",
    path: index2QwGis8PcNMeta?.path ?? "/en/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-ca",
    path: index2QwGis8PcNMeta?.path ?? "/en-ca/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-co",
    path: index2QwGis8PcNMeta?.path ?? "/en-co/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___es-co",
    path: index2QwGis8PcNMeta?.path ?? "/es-co/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-cr",
    path: index2QwGis8PcNMeta?.path ?? "/en-cr/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___es-cr",
    path: index2QwGis8PcNMeta?.path ?? "/es-cr/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-es",
    path: index2QwGis8PcNMeta?.path ?? "/en-es/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___es",
    path: index2QwGis8PcNMeta?.path ?? "/es/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___es-es",
    path: index2QwGis8PcNMeta?.path ?? "/es-es/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-ge",
    path: index2QwGis8PcNMeta?.path ?? "/en-ge/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-gb",
    path: index2QwGis8PcNMeta?.path ?? "/en-gb/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-us",
    path: index2QwGis8PcNMeta?.path ?? "/en-us/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-hk",
    path: index2QwGis8PcNMeta?.path ?? "/en-hk/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-hu",
    path: index2QwGis8PcNMeta?.path ?? "/en-hu/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___hu-hu",
    path: index2QwGis8PcNMeta?.path ?? "/hu-hu/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-in",
    path: index2QwGis8PcNMeta?.path ?? "/en-in/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-ie",
    path: index2QwGis8PcNMeta?.path ?? "/en-ie/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-au",
    path: index2QwGis8PcNMeta?.path ?? "/en-au/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-pa",
    path: index2QwGis8PcNMeta?.path ?? "/en-pa/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___es-pa",
    path: index2QwGis8PcNMeta?.path ?? "/es-pa/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-pe",
    path: index2QwGis8PcNMeta?.path ?? "/en-pe/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___es-pe",
    path: index2QwGis8PcNMeta?.path ?? "/es-pe/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-pl",
    path: index2QwGis8PcNMeta?.path ?? "/en-pl/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___pl-pl",
    path: index2QwGis8PcNMeta?.path ?? "/pl-pl/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-pt",
    path: index2QwGis8PcNMeta?.path ?? "/en-pt/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___pt-pt",
    path: index2QwGis8PcNMeta?.path ?? "/pt-pt/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-ro",
    path: index2QwGis8PcNMeta?.path ?? "/en-ro/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-za",
    path: index2QwGis8PcNMeta?.path ?? "/en-za/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-ae",
    path: index2QwGis8PcNMeta?.path ?? "/en-ae/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-sa",
    path: index2QwGis8PcNMeta?.path ?? "/en-sa/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-om",
    path: index2QwGis8PcNMeta?.path ?? "/en-om/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-kw",
    path: index2QwGis8PcNMeta?.path ?? "/en-kw/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-bh",
    path: index2QwGis8PcNMeta?.path ?? "/en-bh/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-qa",
    path: index2QwGis8PcNMeta?.path ?? "/en-qa/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-ke",
    path: index2QwGis8PcNMeta?.path ?? "/en-ke/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: index2QwGis8PcNMeta?.name ?? "reviews___en-ng",
    path: index2QwGis8PcNMeta?.path ?? "/en-ng/reviews",
    meta: index2QwGis8PcNMeta || {},
    alias: index2QwGis8PcNMeta?.alias || [],
    redirect: index2QwGis8PcNMeta?.redirect || undefined,
    component: () => import("/data/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en",
    path: indexjNcQzb30nMMeta?.path ?? "/en/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-ca",
    path: indexjNcQzb30nMMeta?.path ?? "/en-ca/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-co",
    path: indexjNcQzb30nMMeta?.path ?? "/en-co/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___es-co",
    path: indexjNcQzb30nMMeta?.path ?? "/es-co/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-cr",
    path: indexjNcQzb30nMMeta?.path ?? "/en-cr/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___es-cr",
    path: indexjNcQzb30nMMeta?.path ?? "/es-cr/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-es",
    path: indexjNcQzb30nMMeta?.path ?? "/en-es/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___es",
    path: indexjNcQzb30nMMeta?.path ?? "/es/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___es-es",
    path: indexjNcQzb30nMMeta?.path ?? "/es-es/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-ge",
    path: indexjNcQzb30nMMeta?.path ?? "/en-ge/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-gb",
    path: indexjNcQzb30nMMeta?.path ?? "/en-gb/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-us",
    path: indexjNcQzb30nMMeta?.path ?? "/en-us/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-hk",
    path: indexjNcQzb30nMMeta?.path ?? "/en-hk/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-hu",
    path: indexjNcQzb30nMMeta?.path ?? "/en-hu/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___hu-hu",
    path: indexjNcQzb30nMMeta?.path ?? "/hu-hu/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-in",
    path: indexjNcQzb30nMMeta?.path ?? "/en-in/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-ie",
    path: indexjNcQzb30nMMeta?.path ?? "/en-ie/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-au",
    path: indexjNcQzb30nMMeta?.path ?? "/en-au/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-pa",
    path: indexjNcQzb30nMMeta?.path ?? "/en-pa/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___es-pa",
    path: indexjNcQzb30nMMeta?.path ?? "/es-pa/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-pe",
    path: indexjNcQzb30nMMeta?.path ?? "/en-pe/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___es-pe",
    path: indexjNcQzb30nMMeta?.path ?? "/es-pe/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-pl",
    path: indexjNcQzb30nMMeta?.path ?? "/en-pl/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___pl-pl",
    path: indexjNcQzb30nMMeta?.path ?? "/pl-pl/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-pt",
    path: indexjNcQzb30nMMeta?.path ?? "/en-pt/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___pt-pt",
    path: indexjNcQzb30nMMeta?.path ?? "/pt-pt/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-ro",
    path: indexjNcQzb30nMMeta?.path ?? "/en-ro/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-za",
    path: indexjNcQzb30nMMeta?.path ?? "/en-za/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-ae",
    path: indexjNcQzb30nMMeta?.path ?? "/en-ae/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-sa",
    path: indexjNcQzb30nMMeta?.path ?? "/en-sa/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-om",
    path: indexjNcQzb30nMMeta?.path ?? "/en-om/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-kw",
    path: indexjNcQzb30nMMeta?.path ?? "/en-kw/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-bh",
    path: indexjNcQzb30nMMeta?.path ?? "/en-bh/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-qa",
    path: indexjNcQzb30nMMeta?.path ?? "/en-qa/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-ke",
    path: indexjNcQzb30nMMeta?.path ?? "/en-ke/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjNcQzb30nMMeta?.name ?? "tests-id-slug___en-ng",
    path: indexjNcQzb30nMMeta?.path ?? "/en-ng/tests/:id()/:slug()",
    meta: indexjNcQzb30nMMeta || {},
    alias: indexjNcQzb30nMMeta?.alias || [],
    redirect: indexjNcQzb30nMMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en",
    path: index1s4p7SZOGtMeta?.path ?? "/en/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-ca",
    path: index1s4p7SZOGtMeta?.path ?? "/en-ca/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-co",
    path: index1s4p7SZOGtMeta?.path ?? "/en-co/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___es-co",
    path: index1s4p7SZOGtMeta?.path ?? "/es-co/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-cr",
    path: index1s4p7SZOGtMeta?.path ?? "/en-cr/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___es-cr",
    path: index1s4p7SZOGtMeta?.path ?? "/es-cr/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-es",
    path: index1s4p7SZOGtMeta?.path ?? "/en-es/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___es",
    path: index1s4p7SZOGtMeta?.path ?? "/es/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___es-es",
    path: index1s4p7SZOGtMeta?.path ?? "/es-es/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-ge",
    path: index1s4p7SZOGtMeta?.path ?? "/en-ge/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-gb",
    path: index1s4p7SZOGtMeta?.path ?? "/en-gb/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-us",
    path: index1s4p7SZOGtMeta?.path ?? "/en-us/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-hk",
    path: index1s4p7SZOGtMeta?.path ?? "/en-hk/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-hu",
    path: index1s4p7SZOGtMeta?.path ?? "/en-hu/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___hu-hu",
    path: index1s4p7SZOGtMeta?.path ?? "/hu-hu/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-in",
    path: index1s4p7SZOGtMeta?.path ?? "/en-in/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-ie",
    path: index1s4p7SZOGtMeta?.path ?? "/en-ie/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-au",
    path: index1s4p7SZOGtMeta?.path ?? "/en-au/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-pa",
    path: index1s4p7SZOGtMeta?.path ?? "/en-pa/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___es-pa",
    path: index1s4p7SZOGtMeta?.path ?? "/es-pa/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-pe",
    path: index1s4p7SZOGtMeta?.path ?? "/en-pe/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___es-pe",
    path: index1s4p7SZOGtMeta?.path ?? "/es-pe/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-pl",
    path: index1s4p7SZOGtMeta?.path ?? "/en-pl/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___pl-pl",
    path: index1s4p7SZOGtMeta?.path ?? "/pl-pl/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-pt",
    path: index1s4p7SZOGtMeta?.path ?? "/en-pt/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___pt-pt",
    path: index1s4p7SZOGtMeta?.path ?? "/pt-pt/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-ro",
    path: index1s4p7SZOGtMeta?.path ?? "/en-ro/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-za",
    path: index1s4p7SZOGtMeta?.path ?? "/en-za/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-ae",
    path: index1s4p7SZOGtMeta?.path ?? "/en-ae/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-sa",
    path: index1s4p7SZOGtMeta?.path ?? "/en-sa/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-om",
    path: index1s4p7SZOGtMeta?.path ?? "/en-om/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-kw",
    path: index1s4p7SZOGtMeta?.path ?? "/en-kw/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-bh",
    path: index1s4p7SZOGtMeta?.path ?? "/en-bh/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-qa",
    path: index1s4p7SZOGtMeta?.path ?? "/en-qa/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-ke",
    path: index1s4p7SZOGtMeta?.path ?? "/en-ke/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: index1s4p7SZOGtMeta?.name ?? "tests-id___en-ng",
    path: index1s4p7SZOGtMeta?.path ?? "/en-ng/tests/:id()",
    meta: index1s4p7SZOGtMeta || {},
    alias: index1s4p7SZOGtMeta?.alias || [],
    redirect: index1s4p7SZOGtMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en",
    path: indexi5j1BAjR1wMeta?.path ?? "/en/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-ca",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-ca/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-co",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-co/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___es-co",
    path: indexi5j1BAjR1wMeta?.path ?? "/es-co/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-cr",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-cr/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___es-cr",
    path: indexi5j1BAjR1wMeta?.path ?? "/es-cr/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-es",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-es/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___es",
    path: indexi5j1BAjR1wMeta?.path ?? "/es/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___es-es",
    path: indexi5j1BAjR1wMeta?.path ?? "/es-es/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-ge",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-ge/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-gb",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-gb/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-us",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-us/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-hk",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-hk/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-hu",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-hu/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___hu-hu",
    path: indexi5j1BAjR1wMeta?.path ?? "/hu-hu/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-in",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-in/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-ie",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-ie/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-au",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-au/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-pa",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-pa/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___es-pa",
    path: indexi5j1BAjR1wMeta?.path ?? "/es-pa/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-pe",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-pe/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___es-pe",
    path: indexi5j1BAjR1wMeta?.path ?? "/es-pe/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-pl",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-pl/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___pl-pl",
    path: indexi5j1BAjR1wMeta?.path ?? "/pl-pl/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-pt",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-pt/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___pt-pt",
    path: indexi5j1BAjR1wMeta?.path ?? "/pt-pt/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-ro",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-ro/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-za",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-za/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-ae",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-ae/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-sa",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-sa/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-om",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-om/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-kw",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-kw/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-bh",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-bh/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-qa",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-qa/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-ke",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-ke/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5j1BAjR1wMeta?.name ?? "tests___en-ng",
    path: indexi5j1BAjR1wMeta?.path ?? "/en-ng/tests",
    meta: indexi5j1BAjR1wMeta || {},
    alias: indexi5j1BAjR1wMeta?.alias || [],
    redirect: indexi5j1BAjR1wMeta?.redirect || undefined,
    component: () => import("/data/pages/tests/index.vue").then(m => m.default || m)
  }
]